import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";

import fp from "lodash/fp";
import { join } from "path";
import React, { Component, useState } from "react";
import ReactDOM from "react-dom";
import { withTranslation } from "react-i18next";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import equal from "deep-equal";
import uniqid from "uniqid";
import Loadable from "@react-loadable/revised";
import TreeView from "../../components/tree/TreeView";
import WithSelect from "../../components/select";
import CpmPagination from "../../components/cpm/CpmPagination";
import { RangePicker } from "../../components/datepicker";
import DownloadInfoMessage from "./components/DownloadInfoMessage";
import BucketLockInfoMessage from "./components/BucketLockInfoMessage";
import AccessDenied from "../errors/Error403";
import moment from "moment";

import convertUtcToLocal from "../../cores/convertUtcToLocal";
import convertToByte from "../../cores/convertToByte";

import StorageSyncTooltip from "@/components/tooltip/StorageSyncTooltip";
import menuService from "@services/menuService";

require("../../cores/stringExtension");

import {
    CONSTANTS,
    REGEXP_TRANSCODING_ONLY_VIDEO_FILENAME,
    UPLOAD_FILE_LOCATION_TYPE,
    UPLDOAD_DUPLICATE_ACTION,
    MEDIA_TYPES,
    INGEST_TYPE,
    PROPERTY_PANEL_TYPE,
    JOB_PANEL_TABS,
} from "@constants";

import * as propertyPanelActions from "@modules/propertyPanel";

import * as sourcesActions from "../../modules/sources";
import * as downloadJobsActions from "../../modules/downloadJobs";
import * as settingsActions from "../../modules/settings";
import * as uploadActions from "../../modules/upload";
import * as uploadQueueActions from "../../modules/uploadQueue";
import * as sharesActions from "../../modules/shares";
import * as myJobsActions from "../../modules/myJobs";
import * as rightSideBarActions from "../../modules/rightSideBar";
import * as notificationActions from "../../modules/notification";
import * as createAssetsBulkActions from "../../modules/createAssetsBulk";

import UploadDropzoneProvider from "./components/UploadDropzoneProvider";
import ObjectIcon from "./components/ObjectIcon";
import compareVersions, {
    VERSION_CM_4750_UPLOAD_FOLDERS,
    VERSION_SOURCE_DOWNLOAD,
    VERSION_SOURCE_VIEW_MUTATION,
    VERSION_SOURCE_VIEW_NEW_FOLDER,
    VERSION_CM_7104_STORAGE_TOKEN_BASE_PAGINATION,
    VERSION_CM_7307_DOWNLOAD,
    VERSION_CM_6169_SOURCE_MULTI_ASSET_CREATE,
    VERSION_CM_7441_STORAGE_PREVIEW,
    VERSION_CM_7794_STORAGE_DOWNLOAD_LINK,
    VERSION_CM_8667_STORAGE_V3,
    VERSION_CM_9545_STORAGE_LOCK,
    VERSION_CM_12198_COLLECTION_DOWNLOAD,
    VERSION_CM_15200_PROJECT_MULTI_ACCOUNT,
} from "../../cores/version";
import VersionedComponent from "../../components/VersionedComponent";
import BreadcrumbsWithRouterPath from "../../containers/BreadcrumbsWithRouterPath/BreadcrumbsWithRouterPath";

import DuplicateCheckModal from "../../components/modals/DuplicateCheckModal";
import { createAssetActions } from "../../modules";
import { RESOURCE_TYPES } from "../../cores/cpmUploadService";
import ElementActionItemDownloadV2 from "../asset/ui/detail/ElementActionItemDownloadV2 2";
import { getMediaTypeFromExtension, getUrlInfo } from "../../lib/mime/mime";
import PopperMenu from "../../components/tooltip/PopperMenu";

import { checkIsMobile } from "../../utils/checkmobile";
import { parse } from "querystring";
import {
    ImageBucketS3Off,
    ImageBucketS3On,
    IconArrowUpload,
    IconArrowDownload,
    IconSearch,
    IconTune,
    IconArrowBack,
    IconUp,
    IconMoreHoriz,
    IconFileUpload,
    IconFolderUpload,
    IconMove,
    IconDownload,
    IconShareLink,
    IconDelete,
    ImageFolderSmallOn,
    IconSeparator,
    IconLock,
    IconFileCopyto,
    IconClose,
    IconArrowForward,
    IconFolderAdd,
    IconAssetsAdd,
    IconEditSmall,
} from "@mzc-cloudplex/icons";
import {
    Box,
    Grid,
    Typography,
    Divider,
    IconButton,
    Tooltip,
    Breadcrumbs,
    Button,
    Collapse,
    FormControlLabel,
    Checkbox,
    Table,
    TableHead,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    CircularProgress,
    TextField,
    InputAdornment,
    Popover,
    Stack,
} from "@mzc-pdc/ui";
import theme from "@styles/theme";
import { PageHeader } from "@features/page-header/page-header";
import { PageTools } from "@features/page-tools/page-tools";
import Menu from "@features/menu/menu";
import i18n from "@lib/i18n";
import withCheckPermissionWrapper from "@features/with-check-permission-wrapper/with-check-permission-wrapper";
import { EllipsisTypography } from "@components_v2/ellipsis-tooltip";

const IS_MOBILE = checkIsMobile();

const duplicateModalRef = React.createRef();
const LoadableFolderSelectModal = Loadable({
    loader: () => import("../../components/modals/FolderSelectModal"),
    loading: () => null,
});
const LoadableFileSelectModal = Loadable({
    loader: () => import("../../components/modals/FileSelectModal"),
    loading: () => null,
});
const LoadableSelectStorageModal = Loadable({
    loader: () => import("../../components/modals/SelectStorage"),
    loading: () => null,
});
const LoadableDeleteModal = Loadable({
    loader: () => import("./components/DeleteFilesConfirm"),
    loading: () => null,
});
const LoadableRenameModal = Loadable({
    loader: () => import("../../components/modals/Rename"),
    loading: () => null,
});
const LoadableNewFolderModal = Loadable({
    loader: () => import("../../components/modals/NewFolderModal"),
    loading: () => null,
});
const LoadableCheckSourcesModal = Loadable({
    loader: () => import("./components/ValidationSourcesModal"),
    loading: () => null,
});
const LoadableDownloadLinkModal = Loadable({
    loader: () => import("@components/modals/DownloadLinkModal"),
    loading: () => null,
});

// TODO : Video_list와 동일한 형식, 컴포넌트화 필요

let throttleHandler = false;
let pollingTimeout;
const checkPermissionConfigs = [{ scope: "Project", domain: "Storages" }];

class List extends Component {
    constructor(props) {
        super(props);

        this.bucket = "";
        this.key = "";

        this.state = {
            pending: true,
            activeActionButtonId: -1,
            propertyPanel: {
                type: PROPERTY_PANEL_TYPE.STORAGE,
                targetId: null,
            },
            folderList: [],
            fileList: [],
            total: 0,
            storagePrefix: "",
            showDropdownLayer: false,
            isFolderViewType: "Default",
            bucketPath: null,
            isDragActive: false,
            isActiveModal: {
                folder: false,
                files: false,
            },
            onlyActiveTarget: null,
            selectedItems: [],
            isChecked: false,
            isShowCopyToModal: false,
            isShowMoveToModal: false,
            isShowDeleteConfirmModal: false,
            isShowCheckSourcesModal: false,
            isShowDownloadLinkModal: false,
            actionTarget: null,
            dropDownTarget: null,
            resetValidateModal: false,
            isAssetCreating: false,
            tokenPaginationInfo: {
                totalCount: 0,
                offset: 0,
                data: [],
            },
            isQuickSearch: true,
            advanceSearchKeyword: "",
            isLockedByMeOrUnLocked: true,
        };
    }

    stickyDomRef = React.createRef();
    searchRef = React.createRef();
    controlBarRef = React.createRef();
    getSelectedFiles = () => {
        const { bucket, key } = this;
        const selectedItems = this.state.selectedItems;
        const length = selectedItems.length;
        const converted = [];
        for (let i = 0; i < length; i++) {
            const obj = selectedItems[i];
            if (obj.isFolder) {
                continue;
            } else {
                const _key = key.indexOf("/") !== 0 ? `/${key}` : `${key}`;
                const prefix = `s3://${bucket}${_key}`;
                converted.push({
                    ...obj,
                    fullPath: `${prefix}${obj.path}`,
                });
            }
        }
        return converted;
    };

    componentWillUnmount = () => {
        this.clearPolling();
        window.removeEventListener("beforeunload", this.handleBeforeunload);
        window.removeEventListener("scroll", this.handleScroll);
    };

    createObjectFeatureMenus = (t, v, mutationDisable, hideContents, isLockedByMeOrUnLocked) => {
        // console.log(t, v);
        let menus = [
            {
                skipTranslationLabel: t(`common::label::Create {{name}}`, `Create {{name}}`, {
                    name: t(`common::label::Assets`, `Assets`),
                }),
                onClick: (e) => {
                    this.onClickCreateAsset(v);
                },
                enable: true,
            },
        ];
        if (!hideContents) {
            menus.push({
                skipTranslationLabel: t(`common::label::Create {{name}}`, `Create {{name}}`, {
                    name: t(`common::label::Video`, `Video`),
                }),
                onClick: (e) => {
                    this.onClickCreateJob(v);
                },
                buttonDisabled: this.isDisableCreateJob(v.path),
                enable: false,
            });
        }
        menus = menus.concat([
            {
                skipTranslationLabel: t(`common::label::Share link`, `Share link`),
                onClick: (e) => {
                    this.setShowModal("DOWNLOADLINK", true);
                },
                enable: compareVersions(VERSION_CM_7794_STORAGE_DOWNLOAD_LINK, this.props.stage.version) <= 0,
                separate: true,
            },
            {
                skipTranslationLabel: t(`common::label::Copy to`, `Copy to`),
                onClick: (e) => {
                    this.setShowModal("COPYTO", true);
                },
                enable:
                    compareVersions(VERSION_SOURCE_VIEW_MUTATION, this.props.stage.version) <= 0 && !mutationDisable,
                separate: true,
            },
            {
                skipTranslationLabel: t(`common::label::Move`, `Move`),
                onClick: (e) => {
                    this.setShowModal("MOVETO", true);
                },
                enable:
                    compareVersions(VERSION_SOURCE_VIEW_MUTATION, this.props.stage.version) <= 0 && !mutationDisable,
                buttonDisabled: !isLockedByMeOrUnLocked,
            },
            {
                skipTranslationLabel: t(`common::label::Rename`, `Rename`),
                onClick: (e) => {
                    this.setShowModal("RENAME", true);
                },
                enable:
                    compareVersions(VERSION_SOURCE_VIEW_MUTATION, this.props.stage.version) <= 0 && !mutationDisable,
                buttonDisabled: !isLockedByMeOrUnLocked,
            },
            {
                Component: () => {
                    return (
                        <ElementActionItemDownloadV2
                            onClickDownload={this.createDownloadJob}
                            resourceType={RESOURCE_TYPES.SOURCES}
                            resources={[
                                {
                                    bucket: this.state.bucketPath.bucket,
                                    prefix: this.state.bucketPath.folderPath,
                                    fileName: v.path,
                                },
                            ]}
                            expires={600}
                            projectId={this.props.project.id}
                            disabled={
                                !fp.get(
                                    "[0].downloadable",
                                    this.props.sources.resourceBuckets.filter(
                                        (bucket) => bucket.name === this.state.bucketPath.bucket,
                                    ),
                                ) ||
                                v.isFolder ||
                                (v.status && v.status !== "SYNCED")
                            }
                        />
                    );
                },
                enable: compareVersions(VERSION_SOURCE_DOWNLOAD, this.props.stage.version) <= 0,
            },
            {
                skipTranslationLabel: t(`common::label::Delete`, `Delete`),
                onClick: (e) => {
                    this.setShowModal("DELETE", true);
                },
                enable:
                    compareVersions(VERSION_SOURCE_VIEW_MUTATION, this.props.stage.version) <= 0 && !mutationDisable,
                separate: true,
                buttonDisabled: !isLockedByMeOrUnLocked,
            },
        ]);
        return menus;
    };

    componentDidMount = async () => {
        const { t, history, match, stage, project, SourcesActions, SettingsActions } = this.props;
        window.addEventListener("beforeunload", this.handleBeforeunload);

        SettingsActions.getStageSettings({
            stageId: stage.id,
            apiEndpoint: stage.endpoint,
        });

        if (match.path.indexOf("/cms") === 0) {
            this.setState({
                ...this.state,
                parentPath: "/cms",
                parentPathName: "CMS",
            });
        } else {
            this.setState({
                ...this.state,
                parentPath: "/contents",
                parentPathName: "Contents",
            });
        }

        const localSavedData = localStorage.getItem("sources_saved");
        const localSavedState = localStorage.getItem("sources_state_saved");

        const savedDataJson = localSavedData && JSON.parse(localSavedData);
        const savedStateJson = localSavedState && JSON.parse(localSavedState);

        const localSavedTime = localStorage.getItem("sources_saved_time");
        const savedTime = localSavedTime && moment(localSavedTime);
        const now = moment();
        const timeDiff = savedTime && moment.duration(now.diff(savedTime)).seconds();
        const stageId = stage?.id;
        const projectId = project?.id;
        if (timeDiff && timeDiff <= 5) {
            if (
                stageId &&
                projectId &&
                savedDataJson?.stageId === stageId &&
                savedDataJson?.projectId === projectId &&
                savedStateJson?.stageId === stageId &&
                savedStateJson?.projectId === projectId
            )
                await this.recoveryOldSourcesData(savedDataJson.sources, savedStateJson.state);
        } else {
            let defaultBucket = {};
            if (compareVersions(stage.version, VERSION_CM_15200_PROJECT_MULTI_ACCOUNT) < 0) {
                defaultBucket = await SourcesActions.getResourceBuckets(project.id);
            } else {
                defaultBucket = await SourcesActions.getResourceBucketsV2(project.id);
            }

            const queryParams = parse(this.props.location.search.slice(1));
            if (Object.keys(queryParams).length > 0) {
                const fileData = {
                    bucketName: queryParams.bucketName,
                    children: [],
                    isEmpty: false,
                    isFold: true,
                    isSelected: true,
                    name: queryParams.name,
                    prefix: queryParams.prefix,
                    type: queryParams.prefix === "" ? "bucket" : "folder",
                };
                this.onClickTreePath(fileData, false, false);
                return;
            } else {
                this.onClickTreePath(defaultBucket, false, false);
            }
            this.clearLocalStorage();
        }

        if (history.location.state === "flush") {
            // AssetsActions.resetSearch();
        }
        window.addEventListener("scroll", this.handleScroll);
    };
    handleScroll = (e) => {
        const boxSize = this.stickyDomRef?.current?.getBoundingClientRect();
        const isSticky = boxSize && boxSize.top <= window.scrollY;

        this.setState({
            ...this.state,
            isControlSticky: isSticky,
        });
    };

    shouldComponentUpdate(nextProps, nextState) {
        if (!equal(this.state, nextState)) {
            return true;
        }
        if (!equal(this.props.project, nextProps.project)) {
            return true;
        }
        if (!equal(this.props.sources, nextProps.sources)) {
            return true;
        }
        if (!equal(this.props.createAssetsBulk.showModal, nextProps.createAssetsBulk.showModal)) {
            return true;
        }
        return false;
    }

    componentDidUpdate = async (prevProps, prevState) => {
        const { SourcesActions, sources, stage } = this.props;

        if (!equal(prevProps.project, this.props.project)) {
            SourcesActions.clear();
        }
        if (prevProps.sources.forceReload === false && this.props.sources.forceReload === true) {
            this.otherComponentSetRefresh();
        }
        if (!equal(this.props.sources, prevProps.sources)) {
            const folderList = []; //((sources && sources.objects) || []).filter((o) => o.isFolder);
            const fileList = []; //((sources && sources.objects) || []).filter((o) => !o.isFolder);
            const objects = (this.props.sources && this.props.sources.objects) ?? [];
            const length = objects.length;
            for (let i = 0; i < length; i++) {
                const obj = objects[i];
                if (obj.isFolder) {
                    folderList.push(obj);
                } else {
                    fileList.push(obj);
                }
            }

            const navView = this.props.sources.hierarchy["folder"]?.history?.navView;

            const isLockedByMeOrUnLocked =
                navView?.length > 0
                    ? !navView[0].isLocked || (navView[0].isLocked && navView[0].lockedBy?.id === stage?.user?.id)
                    : true;

            this.setState({
                ...this.state,
                folderList,
                fileList,
                total: length,
                isLockedByMeOrUnLocked,
            });
        }
    };

    clearLocalStorage = () => {
        localStorage.removeItem("sources_saved");
        localStorage.removeItem("sources_state_saved");
        localStorage.removeItem("sources_saved_time");
    };

    recoveryOldSourcesData = async (sources, state) => {
        const { SourcesActions } = this.props;
        const hierarchy = sources.hierarchy;
        const hierarchyActive = "folder";
        await SourcesActions.recoverySourcesData(sources);
        this.setState({ ...this.state, ...state });
        this.refreshFolderList(hierarchy[hierarchyActive].selected);
    };

    handleBeforeunload = (e) => {
        const { sources, stage, project } = this.props;
        const { bucketPath } = this.state;
        if (bucketPath && bucketPath.folderPath !== "") {
            localStorage.setItem(
                "sources_saved",
                JSON.stringify({
                    stageId: stage.id,
                    projectId: project.id,
                    sources,
                }),
            );
            localStorage.setItem(
                "sources_state_saved",
                JSON.stringify({
                    stageId: stage.id,
                    projectId: project.id,
                    state: {
                        ...this.state,
                        selectedItems: [],
                    },
                }),
            );
            localStorage.setItem("sources_saved_time", new Date());
        } else {
            this.clearLocalStorage();
        }
    };

    findTreeItem = (id) => {
        const { sources } = this.props;

        if (!sources.hierarchy.folder.data || sources.hierarchy.folder.data.length === 0) return null;

        return this.findTreeItemRecursive(id, sources.hierarchy.folder.data);
    };

    findTreeItemRecursive = (id, items) => {
        const length = items.length;
        for (let i = 0; i < length; i++) {
            const item = items[i];
            if (item.id === id) return item;
            if (item.children && item.children.length > 0) {
                const childItem = this.findTreeItemRecursive(id, item.children);
                if (childItem) {
                    return childItem;
                }
            }
        }
        return null;
    };

    // 화살표
    onClickTree = async (item) => {
        const { sources, SourcesActions } = this.props;
        const newSources = JSON.parse(JSON.stringify(sources));
        const folderData = newSources.hierarchy.folder.data || [];
        const changeFold = (list, item) => {
            return new Promise((resolve, reject) => {
                const newList = Promise.all(
                    list.map(async (a) => {
                        if (a.id === item.id) {
                            if (a.isFold === false) {
                                const childFolders = await this.getChildrenFolders(a);
                                if (childFolders.length > 0) {
                                    a.children = childFolders;
                                    a.isEmpty = false;
                                } else {
                                    a.children = [];
                                    a.isEmpty = true;
                                }
                            }
                            a.isFold = !a.isFold;
                        } else if (a.children.length > 0) {
                            a.chilren = await changeFold(a.children, item);
                        }
                        return a;
                    }),
                );
                resolve(newList);
            });
        };

        const newFolderData = await changeFold(folderData, item);
        SourcesActions.updateState({
            hierarchy: {
                ...newSources.hierarchy,
                folder: {
                    ...newSources.hierarchy.folder,
                    data: newFolderData,
                },
            },
            updatedAt: new Date(),
        });
    };

    getChildrenFolders = async (item) => {
        const { SourcesActions } = this.props;
        if (!item) return [];

        const key = item.type !== "bucket" ? item.prefix : "";
        const bucketName = item.bucketName ?? this.getBucketName(item.code);
        if (!bucketName) return [];

        const response = await SourcesActions.getFolders(bucketName, key);

        if (response.data && response.data.items && response.data.items.length > 0)
            return this.convertToFolders(response.data.items, item);
        else return [];
    };

    getObjects = async (item, nextToken, isChangedOffset) => {
        if (!item)
            return {
                bucket: "",
                key: "",
                items: [],
            };

        const { SourcesActions } = this.props;
        const key = item.type !== "bucket" ? item.prefix : "";
        const bucketName = item.bucketName ?? this.getBucketName(item.code);
        this.bucket = bucketName;
        this.key = key;
        if (!bucketName) return [];
        const response = await SourcesActions.getObjects(bucketName, key, nextToken);

        if (response && response.data) {
            if (!isChangedOffset) {
                const nextToken = response.data.nextToken;
                this.state.tokenPaginationInfo.data.push({
                    page: this.state.tokenPaginationInfo.data.length + 1,
                    nextToken,
                });
            }
            const pageCount = this.state.tokenPaginationInfo.data.length;
            const offset = isChangedOffset
                ? this.props.sources.search.offset
                : (pageCount - 1) * this.props.sources.search.defaultViewCountByToken;
            this.setState({
                ...this.state,
                tokenPaginationInfo: {
                    offset,
                    data: this.state.tokenPaginationInfo.data,
                },
            });

            return {
                items: response.data.items || [],
            };
        } else {
            this.setState({
                ...this.state,
                tokenPaginationInfo: {
                    totalCount: 0,
                    offset: 0,
                    data: [],
                },
            });
        }

        return {
            items: [],
        };
    };

    convertToFolders(folders, item) {
        return folders && folders.length
            ? folders.map((v) => {
                  if (item && item.children && item.children.length) {
                      const check = item.children.find((obj) => obj.name === v.path);

                      if (check) return check;
                  }
                  const _id = uniqid();
                  return {
                      id: `${_id}`,
                      code: item && item.code ? `${item.code}_${_id}` : `${_id}`,
                      children: [],
                      name: v.path,
                      prefix: `${item.prefix}${v.path}/`,
                      isEmpty: false,
                      isFold: false,
                      isSelected: false,
                      type: "folder",
                  };
              })
            : [];
    }

    getBucketName = (code) => {
        const bucket = this.getTargetBucket(code);
        return bucket && bucket.name;
    };

    onClickTreePath = async (item, blockUploadListClear, allowedFold) => {
        this.clearPolling();
        if (!item) {
            this.setState({ ...this.state, pending: false, selectedItems: [] });
            return;
        }
        const { sources, SourcesActions, UploadQueueActions } = this.props;
        if (blockUploadListClear) {
            UploadQueueActions.clear();
        }

        const bucketPath = this.makeUploadBucketValue(item);
        if (bucketPath) {
            bucketPath.uploadDisabled = this.onDropDisabled(item);
            bucketPath.downloadDisabled = this.onCheckDownloadDisabled(item);
        }

        //this.onClickReset();
        this.setState({
            ...this.state,
            pending: true,
            bucketPath,
            selectedItems: [],
            isChecked: false,
            tokenPaginationInfo: {
                totalCount: 0,
                offset: 0,
                data: [],
            },
        });

        await this.changeHierarchySelected(item, allowedFold);
        const folder = sources.hierarchy.folder;
        const objects = await this.getObjects(item);
        const historyIndex = (folder && folder.history && folder.history.index) || 0;
        const historyItems = (folder && folder.history && folder.history.items) || [];
        const navView = await this.convertToNavView(folder.data, item);

        SourcesActions.updateState({
            isSearched: false,
            hierarchy: {
                ...sources.hierarchy,
                pending: false,
                error: false,
                folder: {
                    ...folder,
                    history: {
                        index:
                            historyItems?.[historyItems.length - 1]?.id === item.id ? historyIndex : historyIndex + 1,
                        items:
                            historyItems?.[historyItems.length - 1]?.id === item.id
                                ? [...historyItems]
                                : [...historyItems, item],
                        navView,
                    },
                    selected: item,
                },
            },
            objects: objects.items,
        });
        this.setState({ ...this.state, pending: false, selectedItems: [] });
    };

    getTargetBucket = (code) => {
        const { sources } = this.props;
        const split = code.split("_");
        if (split.length > 0) {
            const bucketItemCode = split[0];
            if (sources && sources.hierarchy && sources.hierarchy.folder && sources.hierarchy.folder.data) {
                const targetBucket = sources.hierarchy.folder.data.find((v) => v.code === bucketItemCode);
                return targetBucket;
            }
        }

        return null;
    };
    getTargetBucketByName = (name) => {
        const { sources } = this.props;
        if (sources && sources.hierarchy && sources.hierarchy.folder && sources.hierarchy.folder.data) {
            const targetBucket = sources.hierarchy.folder.data.find((v) => v.name === name);
            return targetBucket;
        }

        return null;
    };

    changeHierarchySelected = async (item, allowdFold = true) => {
        const folderDataChangeIsSelected = (folderData, item) => {
            if (!folderData) return [];
            for (let folder of folderData) {
                folder.isSelected = false;
                if (folder.children.length > 0) {
                    folder.children = folderDataChangeIsSelected(folder.children, item);
                }
                if (folder.id === item.id) {
                    folder.isSelected = false;
                }
            }
            return folderData;
        };
        const { sources } = this.props;
        const hierarchy = sources.hierarchy;

        item.children = await this.getChildrenFolders(item);
        if (hierarchy.folder.selected && Object.keys(hierarchy.folder.selected).length) {
            hierarchy.folder.selected.isSelected = false;
        }
        if (item.hasOwnProperty("isFold") && allowdFold) {
            item.isFold = true;
        }

        folderDataChangeIsSelected(hierarchy.folder.data, item);
        item.isSelected = true;
        item.isEmpty = item.children.length > 0 ? false : true;
        return item;
    };

    convertToNavView = (data, item) => {
        const bucket = item.bucketName ? this.getTargetBucketByName(item.bucketName) : this.getTargetBucket(item.code);
        let treeNavigation = [];

        function createFolderNav(code, data) {
            let navigation = [];
            let arrayCodes = code.split("_");
            let id = arrayCodes.splice(0, 1)[0];
            const target = data.find((item) => item.id === id) || [];
            let rest = [];
            if (arrayCodes.length > 0) {
                rest = createFolderNav(arrayCodes.join("_"), target.children || []);
            }
            navigation = navigation.concat(target, rest);
            return navigation;
        }

        function createFolderNavByName(name, data, changeHierarchySelected) {
            let navigation = [];
            let arrayNames = name.split("/");
            let targetName = arrayNames.splice(0, 1)[0];
            const target = data.find((folder) => folder.name === targetName) || [];
            let rest = [];

            if (name == "") return;
            if (arrayNames.length > 0) {
                changeHierarchySelected(target);
                rest =
                    createFolderNavByName(arrayNames.join("/"), target.children || [], changeHierarchySelected) || [];
            }
            navigation = navigation.concat(target, rest);
            return navigation;
        }

        try {
            if (item.bucketName) {
                treeNavigation = createFolderNavByName(
                    `${item.bucketName}/${item.prefix}`,
                    data,
                    this.changeHierarchySelected,
                );
            } else {
                treeNavigation = createFolderNav(item.code, data);
                if (!treeNavigation.find((t) => t.id === item.id)) {
                    treeNavigation.push(item);
                }
            }
        } catch (e) {
            console.error("convertToNavView error : ", e);
            if (bucket) {
                treeNavigation.push(bucket);
            }
        }
        return treeNavigation.map((item, index) => {
            item.isSelected = index === treeNavigation.length - 1 ? true : false;
            return item;
        });
    };

    getNavElementIconClass = (item) => {
        let result = "";
        switch (item.type) {
            case "folder":
                result = "folder";
                break;

            case "category":
                result = "category";
                break;

            case "categoryGroup":
                result = "category-group";
                break;

            case "assets":
                result = "folder-assets";
                break;

            case "bucket":
                result = "bucket";
                break;
        }

        if (item.uploadable) {
            // if ((item.uploadable)) {
            //     result += "-upload";
            // }
            if ((!item.isGroup && !item.isSelected) || (item.isGroup && !item.isActive)) {
                result += "-disabled";
            }
        }

        return result;
    };

    getBucketLockIcon = (item) => {
        if (!item.isLocked) return null;
        const { t } = this.props;
        const lockedBy = item.lockedBy;
        const lockedAt = item.lockedAt;

        return (
            <VersionedComponent version={VERSION_CM_9545_STORAGE_LOCK}>
                <Tooltip
                    title={
                        <>
                            <Typography variant="body4_700" mb="8px" component={"p"}>
                                {t(`common::label::Locked by`)}
                            </Typography>
                            <Typography variant={"body2_400"} component={"p"}>
                                {lockedBy?.id !== this.props.stage?.user?.id
                                    ? `${lockedBy.name}(${lockedBy.username})`
                                    : t(`common::label::Me`)}
                            </Typography>
                            <Typography variant={"body2_400"} component={"p"}>
                                {convertUtcToLocal(lockedAt)}
                            </Typography>
                        </>
                    }
                    color="primary"
                >
                    <Box
                        sx={{
                            display: `inline-flex`,
                            alignItems: `center`,
                            justifyContent: `center`,
                            verticalAlign: `middle`,
                            borderRadius: `100%`,
                            width: `18px`,
                            height: `18px`,
                            // marginRight: `6px`,
                            backgroundColor:
                                lockedBy?.id === this.props.stage?.user?.id ? "#757486" : theme.palette.warning.main,
                        }}
                    >
                        <IconLock size={10} htmlColor={"#fff"} />
                    </Box>
                </Tooltip>
            </VersionedComponent>
        );
    };

    onClickNavPrev = async () => {
        const { sources, SourcesActions } = this.props;
        this.clearPolling();
        const hierarchy = sources.hierarchy;
        const history = hierarchy.folder.history;
        const prevItem = history.items[history.index - 1];

        if (history.index > 0) {
            const bucketPath = this.makeUploadBucketValue(prevItem);
            if (bucketPath) bucketPath.uploadDisabled = this.onDropDisabled(prevItem);
            this.setState({
                ...this.state,
                bucketPath,
                selectedItems: [],
                isChecked: false,
                tokenPaginationInfo: {
                    totalCount: 0,
                    offset: 0,
                    data: [],
                },
            });
            await this.changeHierarchySelected(prevItem);
            const objects = await this.getObjects(prevItem);

            SourcesActions.updateState({
                hierarchy: {
                    ...sources.hierarchy,
                    folder: {
                        ...sources.hierarchy.folder,
                        history: {
                            ...history,
                            index: history.index - 1,
                            navView: this.convertToNavView(hierarchy.folder.data, prevItem),
                        },
                        data: [].concat(hierarchy.folder.data),
                        selected: prevItem,
                    },
                },
                objects: objects.items,
            });
        }
    };

    onClickNavNext = async () => {
        const { sources, SourcesActions } = this.props;
        this.clearPolling();
        const hierarchy = sources.hierarchy;
        const history = hierarchy.folder.history;
        const nextItem = history.items[history.index + 1];

        if (history.index !== history.items && history.items.length - 1) {
            const bucketPath = this.makeUploadBucketValue(nextItem);
            if (bucketPath) bucketPath.uploadDisabled = this.onDropDisabled(nextItem);
            this.setState({
                ...this.state,
                bucketPath,
                selectedItems: [],
                isChecked: false,
                tokenPaginationInfo: {
                    totalCount: 0,
                    offset: 0,
                    data: [],
                },
            });
            await this.changeHierarchySelected(nextItem);
            const objects = await this.getObjects(nextItem);

            SourcesActions.updateState({
                hierarchy: {
                    ...sources.hierarchy,
                    folder: {
                        ...sources.hierarchy.folder,
                        history: {
                            ...history,
                            index: history.index + 1,
                            navView: this.convertToNavView(hierarchy.folder.data, nextItem),
                        },
                        data: [].concat(hierarchy.folder.data),
                        selected: nextItem,
                    },
                },
                objects: objects.items,
            });
        }
    };

    findTarget = (list, params) => {
        let find;
        const key = Object.keys(params)[0];
        const value = Object.values(params)[0];
        for (let item of list) {
            find = list.find((check) => check[key] === value);
            find = find ? find : this.findTarget(item.children, params);
            if (find) {
                break;
            }
        }
        return find;
    };

    onClickUpperPath = async () => {
        const { sources, SourcesActions } = this.props;
        this.clearPolling();
        const hierarchy = sources.hierarchy;
        const history = hierarchy.folder.history;
        const selected = hierarchy.folder.selected;
        const code = selected.code.split("_");
        const parentId = code[code.indexOf(selected.id) - 1];

        if (parentId) {
            // const item = history.items.find((item) => item.id === parentId);
            const item = this.findTarget(hierarchy.folder.data, { id: parentId });
            const bucketPath = this.makeUploadBucketValue(item);
            if (bucketPath) bucketPath.uploadDisabled = this.onDropDisabled(item);
            this.setState({
                ...this.state,
                bucketPath,
                selectedItems: [],
                isChecked: false,
                tokenPaginationInfo: {
                    totalCount: 0,
                    offset: 0,
                    data: [],
                },
            });

            await this.changeHierarchySelected(item);
            const objects = await this.getObjects(item);

            SourcesActions.updateState({
                hierarchy: {
                    ...sources.hierarchy,
                    folder: {
                        ...sources.hierarchy.folder,
                        history: {
                            index: history.index + 1,
                            items: history.items.slice(0, history.index + 1).concat(item),
                            navView: this.convertToNavView(hierarchy.folder.data, item),
                        },
                        data: [].concat(hierarchy.folder.data),
                        selected: item,
                    },
                },
                objects: objects.items,
            });
        }
    };

    onChangeSearchKeyword = (value) => {
        const { SourcesActions } = this.props;

        SourcesActions.updateSearch({
            keyword: value,
        });
    };

    onSubmitForm = async (searchCondition, nextToken, isChangedOffset, paginationInfo) => {
        const { sources, SourcesActions } = this.props;
        this.clearPolling();
        this.setState((prevState) => ({
            ...prevState,
            pending: true,
            tokenPaginationInfo: paginationInfo || {
                totalCount: 0,
                offset: 0,
                data: [],
            },
            isQuickSearch: true,
        }));
        if (searchCondition) {
            SourcesActions.updateSearch({
                ...searchCondition,
            });
        }
        const current = sources.hierarchy.folder.selected;
        const objects = await this.getObjects(current, nextToken, isChangedOffset);
        if (objects) {
            SourcesActions.updateState({
                objects: objects.items,
            });
        }
        this.setState((prevState) => ({
            ...prevState,
            pending: false,
        }));
    };

    onClickReset = () => {
        const { SourcesActions } = this.props;
        this.setState({ ...this.state, advanceSearchKeyword: "" });
        SourcesActions.resetSearch();
        //this.onSubmitForm({ offset: 0 });
    };

    onClickToggleActionButton = (target) => {
        const path = target.path;
        const fileName = path.substring(path.lastIndexOf("/") + 1, path.length);
        let disabled = false;
        if (!REGEXP_TRANSCODING_ONLY_VIDEO_FILENAME.test(fileName)) disabled = true;
        this.setState({
            ...this.state,
            dropDownTarget: {
                target,
                disabledCreateJob: disabled,
            },
            actionTarget: target,
        });
        // SourcesActions.toggleActionButton({ path, disabledCreateJob: disabled });
    };

    isDisableCreateJob = (path) => {
        const fileName = path.substring(path.lastIndexOf("/") + 1, path.length);
        let disabled = false;
        if (!REGEXP_TRANSCODING_ONLY_VIDEO_FILENAME.test(fileName)) {
            disabled = true;
        }
        return disabled;
    };

    onClickCreateAsset = (object) => {
        const { sources, location } = this.props;
        const { spaceId, projectId } = menuService.parse(location.pathname);
        const current = sources.hierarchy.folder.selected;
        const currentBucket = this.getTargetBucket(current.code);
        const sourceUrl = encodeURIComponent(
            `https://${currentBucket.name}.s3.amazonaws.com${
                current.prefix ? "/" + current.prefix.removeEndingSlash() : ""
            }/${object.path}`,
        );
        const queryParameter = `sourceUrl=${sourceUrl}`;
        const url = `${window.location.origin}${menuService.paths.assetsAssetCreate(
            spaceId,
            projectId,
        )}?${queryParameter}`;

        window.open(url, `_blank`);
    };

    onClickCreateJob = (object) => {
        const { sources, location } = this.props;
        const { spaceId, projectId } = menuService.parse(location.pathname);
        const current = sources.hierarchy.folder.selected;
        const currentBucket = this.getTargetBucket(current.code);
        const sourceUrl = encodeURIComponent(
            `s3://${currentBucket.name}${current.prefix ? "/" + current.prefix.removeEndingSlash() : ""}/${
                object.path
            }`,
        );
        const queryParameter = `url=${sourceUrl}`;
        const url = `${window.location.origin}${menuService.paths.videoCreate(spaceId, projectId)}?${queryParameter}`;

        window.open(url, `_blank`);
    };

    onChangeOffset = (page) => {
        const { sources, SourcesActions } = this.props;

        const offset = page !== undefined ? (page - 1) * sources.search.limit : sources.search.offset;

        this.onSubmitForm({ offset });
    };

    onChangeLimit = (limit) => {
        const { SourcesActions } = this.props;

        this.onSubmitForm({ limit, offset: 0 });
    };

    getObjectName = (path) => {
        const splitPath = path.split("/");

        return splitPath[splitPath.length - 1];
    };

    /**
     * Upload 파일 Drag & Drop Functions
     * sp46에서 추가함
     */

    getObjectsData = async (item) => {
        // 오로지 polling용 get data function
        const { SourcesActions } = this.props;
        const key = item.type !== "bucket" ? item.prefix : "";
        const bucketName = item.bucketName ?? this.getBucketName(item.code);
        if (!bucketName) {
            return [];
        }
        const { data } = await SourcesActions.getObjectsData(bucketName, key);
        if (data) {
            return data.items;
        } else {
            return [];
        }
    };

    pollingForUnSyncedFiles = async (item) => {
        // 요건 list에서 status가 SYNCED 가 아닐경우 해당 list들을 폴링해서 재갱신해주는 로직으로
        // 백엔드가 개선되면 불필요해질 로직임
        const { stage } = this.props;
        const doSomething = (item) => {
            return new Promise(
                (resolve) =>
                    (pollingTimeout = setTimeout(async () => {
                        try {
                            const results = await this.getObjectsData(item);
                            if (
                                compareVersions(stage.version, VERSION_CM_8667_STORAGE_V3) < 0 &&
                                results.filter((item) => item.status !== "SYNCED").length > 0
                            ) {
                                resolve("POLLING");
                            } else {
                                resolve("SUCCEED");
                            }
                        } catch (error) {
                            resolve("ERROR");
                        }
                    }, 2000)),
            );
        };

        const loop = (item) => {
            return doSomething(item).then((results) => {
                if (results === "SUCCEED" || results === "ERROR") {
                    return results;
                } else {
                    if (pollingTimeout) {
                        return loop(item);
                    }
                    return "CANCELED";
                }
            });
        };

        return new Promise((resolve, reject) => {
            loop(item)
                .then((results) => {
                    resolve(results);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    clearPolling = () => {
        if (pollingTimeout) {
            clearTimeout(pollingTimeout);
        }
    };

    getCurrencPageToken = () => {
        if (compareVersions(this.props.stage.version, VERSION_CM_7104_STORAGE_TOKEN_BASE_PAGINATION) >= 0) {
            const page =
                this.props.sources.search.offset === 0
                    ? 1
                    : this.props.sources.search.offset / this.props.sources.search.defaultViewCountByToken + 1;
            let prevPage;
            this.state.tokenPaginationInfo.data.map((v) => {
                if (v.page === page - 1) prevPage = v;
            });

            return prevPage ? prevPage.nextToken : "";
        } else return "";
    };

    refreshFolderList = async (item, skipLoading, skipChangeHierarchy) => {
        const token = this.getCurrencPageToken();

        this.clearPolling();
        const { SourcesActions } = this.props;
        if (!skipLoading) {
            this.setState({ ...this.state, pending: true });
        }
        if (!skipChangeHierarchy) {
            const hierarchy = await this.changeHierarchySelected_v2(item);

            const objects = await this.getObjects(item, token, true);

            SourcesActions.updateState({
                isSearched: false,
                hierarchy: {
                    ...hierarchy,
                    folder: {
                        ...hierarchy.folder,
                        history: {
                            ...hierarchy.folder.history,
                            navView: hierarchy.folder.history.navView.map((item, index) => {
                                item.isSelected = index === hierarchy.folder.history.navView.length - 1 ? true : false;
                                return item;
                            }),
                        },
                    },
                },
                objects: objects.items,
            });
            const bucketPath = this.makeUploadBucketValue(item);
            if (bucketPath) {
                bucketPath.uploadDisabled = this.onDropDisabled(item);
                bucketPath.downloadDisabled = this.onCheckDownloadDisabled(item);
            }
            this.setState({
                ...this.state,
                pending: false,
                selectedItems: [],
                isChecked: false,
                bucketPath,
            });
            if (
                objects &&
                objects.items &&
                objects.items.filter(
                    (item) =>
                        compareVersions(this.props.stage.version, VERSION_CM_8667_STORAGE_V3) < 0 &&
                        item.status !== "SYNCED",
                ).length > 0
            ) {
                // 갱신 했는데 미처 상태값이 안 바뀐 애들을 위한 로직
                // 현재 이 로직은 에러나 캔슬레이션일 경우 해당 가비지 데이터를 날리는 로직이 있기에 사용할 수 있음.
                const results = await this.pollingForUnSyncedFiles(item);
                if (results === "SUCCEED") {
                    this.refreshFolderList(item, null, true);
                }
            }
        } else {
            const objects = await this.getObjects(item, token, true);
            SourcesActions.updateState({
                objects: objects.items,
            });
            this.setState({ ...this.state, pending: false, selectedItems: [], isChecked: false });
        }
    };

    changeHierarchySelected_v2 = async (item) => {
        const { sources } = this.props;
        const hierarchy = sources.hierarchy;
        item.children = await this.getChildrenFolders(item);
        item.isEmpty = item.children.length > 0 ? false : true;
        item.isSelected = true;
        if (hierarchy.folder.selected && Object.keys(hierarchy.folder.selected).length > 0) {
            hierarchy.folder.selected.isSelected = false;
        }
        // hierarchy.folder.history.navView = this.convertToNavView(hierarchy.folder.data, item);
        const newHierarchy = {
            ...hierarchy,
            folder: {
                ...hierarchy.folder,
                selected: item,
            },
        };
        return newHierarchy;
    };

    otherComponentSetRefresh = () => {
        const { sources } = this.props;
        const hierarchy = sources.hierarchy;
        const hierarchyActive = "folder";
        this.refreshFolderList(hierarchy[hierarchyActive].selected);
    };

    onSelectFilesUpload = (files, uploadDuplicateAction) => {
        let selectedFiles = files || [];
        let isFolder = false;
        selectedFiles.map((item) => {
            item.fullPath = item.fullPath === item.name ? "/" : item.fullPath === `/${item.name}` ? "/" : item.fullPath;
            isFolder = isFolder ? isFolder : item.fullPath.length > 1 && item.fullPath.indexOf("/") > -1 ? true : false;
            return item;
        });
        this.startUploadProgress(selectedFiles, isFolder, uploadDuplicateAction);
    };

    onDropFile = async (accepted, rejected, extendPath) => {
        const { sources } = this.props;
        let selectedFiles = (accepted || []).filter(({ isFolder }) => !isFolder);
        let isFolder = false;

        if (!selectedFiles || Object.keys(selectedFiles).length === 0) {
            return;
        }

        selectedFiles.map((item) => {
            item.displayName = item.name;
            item.locationType = UPLOAD_FILE_LOCATION_TYPE.LOCAL;
            // item.fullPath = item.fullPath === item.name ? "/" : item.fullPath === `/${item.name}` ? "/" : item.fullPath;
            item.fullPath = item.path[0] === "/" ? item.path : `/`;
            isFolder = isFolder ? isFolder : item.fullPath.length > 1 && item.fullPath.indexOf("/") > -1 ? true : false;
            if (extendPath) {
                item.fullPath = extendPath + item.fullPath;
            }
            return item;
        });

        if (extendPath) {
            const item = sources.hierarchy.folder.selected.children.find((item) => `/${item.name}` === extendPath);
            this.startUploadProgress(selectedFiles, isFolder, null, item);
            // await this.onClickTreePath(item)
        } else {
            this.startUploadProgress(selectedFiles, isFolder);
        }
    };

    onDropTreeFile = async (accepted, rejected, target) => {
        const {} = this.props;
        let selectedFiles = (accepted || []).filter(({ isFolder }) => !isFolder);
        let isFolder = false;
        selectedFiles.map((item) => {
            item.fullPath = item.path === item.name ? "/" : item.path === `/${item.name}` ? "/" : item.path;
            isFolder = isFolder ? isFolder : item.fullPath.length > 1 && item.fullPath.indexOf("/") > -1 ? true : false;
            return item;
        });
        await this.onClickTreePath(target);
        this.startUploadProgress(selectedFiles, isFolder);
    };

    startUploadProgress = async (
        selectedFiles,
        isFolder,
        uploadDuplicateAction = UPLDOAD_DUPLICATE_ACTION.ASK,
        extendPathItem,
    ) => {
        const { UploadQueueActions, sources, location, RightSideBarActions } = this.props;
        const bucketPath = this.state.bucketPath;
        const hierarchy = sources.hierarchy;
        const hierarchyActive = "folder";
        const locationType = UPLOAD_FILE_LOCATION_TYPE.LOCAL || "Local";

        const jobKey = await UploadQueueActions.makeUploadQueueJob({
            locationType,
            files: selectedFiles.map((item) => {
                item.id = uniqid();
                return item;
            }),
            bucketPath,
            isFolder,
        });

        RightSideBarActions.toggleActive({
            type: CONSTANTS("RIGHT_SIDE_BAR_TYPES").MY_JOB,
            activeTab: JOB_PANEL_TABS.SOURCE_UPLOAD,
            activeFlag: true,
        });
    };

    onDropDisabled = (target) => {
        const { sources } = this.props;
        const bucketPath = this.makeUploadBucketValue(target);
        if (!bucketPath) return true;

        const resourceBuckets = sources.resourceBuckets;
        const currentBucket = resourceBuckets.filter((item) => item.name === bucketPath.bucket)[0];

        return currentBucket ? !currentBucket.uploadable : true;
    };

    onCheckDownloadDisabled = (target) => {
        const { sources } = this.props;
        const bucketPath = this.makeUploadBucketValue(target);
        if (!bucketPath) return true;

        const resourceBuckets = sources.resourceBuckets;
        const currentBucket = resourceBuckets.filter((item) => item.name === bucketPath.bucket)[0];

        return currentBucket ? !currentBucket.downloadable : true;
    };

    makeUploadBucketValue = (item) => {
        const { sources } = this.props;
        const folderData = sources.hierarchy.folder.data;
        if (!folderData || !item) {
            return;
        }

        function findTree(list, target) {
            for (let item of list) {
                let foundTarget;
                if (item.children) {
                    foundTarget = findTree(item.children, target);
                    if (foundTarget) {
                        const parent = item.name;
                        return [parent].concat(foundTarget);
                    }
                }
                if (target.bucketName) {
                    if (item.name === target.bucketName) return [item.name];
                } else if (item.id === target.id) {
                    return [item.name];
                }
            }
        }

        const treeArray = findTree(folderData, item);

        return {
            bucket: treeArray && treeArray.splice(0, 1)[0],
            folderPath: treeArray && treeArray.join("/"),
        };
    };

    onClickToggleModal = (target) => {
        const active = !this.state.isActiveModal[target];

        this.setState({
            ...this.state,
            isActiveModal: {
                ...this.state.isActiveModal,
                [target]: active,
            },
        });
    };

    onChangeAllSelectedItems = (isChecked) => {
        const { sources, stage } = this.props;
        if (isChecked) {
            const newSelected = sources.objects.filter(
                (item) => compareVersions(stage.version, VERSION_CM_8667_STORAGE_V3) >= 0 || item.status === "SYNCED",
            );
            this.setState({
                ...this.state,
                selectedItems: newSelected,
                isChecked,
            });
        } else {
            this.setState({
                ...this.state,
                selectedItems: [],
                isChecked,
            });
        }
    };

    onChangeSelectItem = (target) => {
        const { selectedItems } = this.state;

        if (selectedItems.find((item) => item.path === target.path && item.lastModified === target.lastModified)) {
            const newSelectedItems = selectedItems.filter((v) => v !== target);
            this.setState({
                ...this.state,
                selectedItems: newSelectedItems,
                isChecked: newSelectedItems.length === 0 ? false : true,
            });
        } else {
            this.setState({
                ...this.state,
                selectedItems: [...selectedItems, target],
                isChecked: true,
            });
        }
    };

    setIsShowCheckSourcesModal = (flag, items, passParams, adjustState = {}) => {
        this.setState({
            ...this.state,
            isShowCheckSourcesModal: flag,
            validationFiles:
                flag === true
                    ? {
                          items,
                          ...passParams,
                      }
                    : null,
            ...adjustState,
        });
    };

    setIsShowDownloadLinkModal = (flag = {}) => {
        this.setState({
            ...this.state,
            isShowDownloadLinkModal: flag,
        });
    };

    checkJobStatus = async (jobId) => {
        const { SourcesActions } = this.props;
        const { bucketPath } = this.state;
        const bucketName = bucketPath.bucket;

        try {
            const response = await SourcesActions.getJobStatus(bucketName, jobId);
            const { results } = response.data;
            return results[0].status;
        } catch (error) {
            throw "FAILED";
        }
    };

    startPollingJobStatus = async (jobId) => {
        const doSomething = (jobId) => {
            return new Promise((resolve, reject) =>
                setTimeout(async () => {
                    try {
                        const results = await this.checkJobStatus(jobId);
                        resolve(results);
                    } catch (error) {
                        reject(error);
                    }
                }, 2000),
            );
        };

        const loop = (jobId) =>
            doSomething(jobId).then((results) => {
                if (results === "SUCCEED" || results === "FAILED") {
                    return results;
                } else {
                    return loop(jobId);
                }
            });

        return new Promise((resolve, reject) => {
            loop(jobId)
                .then((results) => {
                    resolve(results);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    onClickDeleteSources = async (targets) => {
        if (throttleHandler) {
            return;
        }
        const { SourcesActions, MyJobsActions } = this.props;
        const { bucketPath } = this.state;
        const bucketName = bucketPath.bucket;
        const folderPath = bucketPath.folderPath ? `/${bucketPath.folderPath}` : "";
        const items = targets.map((item) => {
            return {
                path: `${folderPath}/${item.path}`,
                isFolder: item.isFolder,
            };
        });
        try {
            throttleHandler = true;
            const response = await SourcesActions.deleteSources(bucketName, items);
            const { jobId } = response.data;
            throttleHandler = false;
            const status = await this.startPollingJobStatus(jobId);
            if (status === "FAILED") {
                // this.toastJustMessage('error', `Delete excution failed.`)
                throw new Error(`Delete error.`);
            }
            return response;
        } catch (error) {
            this.toastErrorMessage(error, "DELETE");
            this.clearThrottleHandler();
            await MyJobsActions.getMyJobs("ALL");
            throw error;
        }
    };

    afterMutationWorks = async (action = "Action requests", jobId) => {
        const { MyJobsActions, SourcesActions } = this.props;
        let partialComplete = "";
        if (jobId) {
            const { bucketPath } = this.state;
            const bucketName = bucketPath.bucket;
            const response = await SourcesActions.getJobStatus(bucketName, jobId);
            const { results } = response.data;
            if (results && results[0].partialFailure) {
                partialComplete = "Partial ";
            }
        }
        this.toastJustMessage("success", `${partialComplete}${action} completed.`);
        await MyJobsActions.getMyJobs("ALL");
        this.delayRefreshFoldersList(1000);
    };

    onClickRenameSource = async (target, newName, option) => {
        if (throttleHandler) {
            return;
        }
        const { SourcesActions, MyJobsActions } = this.props;
        const { bucketPath } = this.state;
        const bucketName = bucketPath.bucket;
        const folderPath = bucketPath.folderPath ? `/${bucketPath.folderPath}` : "";
        let to = `${bucketName}${folderPath}/${newName}`;
        const items = [];
        items.push({
            path: `${folderPath}/${target.path}`,
            isFolder: target.isFolder,
        });
        try {
            throttleHandler = true;
            // TODO: rename은 왜 duplication check 안 하나?
            // TODO: Max request payload size: 262144
            const response = await SourcesActions.renameSources(bucketName, to, items);
            throttleHandler = false;
            const { jobId } = response.data;
            const status = await this.startPollingJobStatus(jobId);
            if (status === "FAILED") {
                // this.toastJustMessage('error', `Rename excution failed.`)
                throw new Error(`Rename error.`);
            }
            return response;
        } catch (error) {
            this.toastErrorMessage(error, "RENAME");

            this.clearThrottleHandler();
            await MyJobsActions.getMyJobs("ALL");
            throw error;
        }
    };

    afterCheckSubmit = async (type, bucketName, to, targets) => {
        const { SourcesActions, MyJobsActions } = this.props;
        const { bucketPath } = this.state;
        throttleHandler = false;
        try {
            let response;
            // TODO: Max request payload size: 262144
            if (type === "MOVE") {
                response = await SourcesActions.moveSources(bucketPath.bucket, to, targets, null, true);
            } else if (type === "COPY") {
                response = await SourcesActions.copySources(bucketPath.bucket, to, targets, null, true);
            }
            if (type === "MOVE") {
                this.setShowModal("MOVETO", false);
            } else if (type === "COPY") {
                this.setShowModal("COPYTO", false);
            }

            // const { jobId } = response.data;

            return response;
        } catch (error) {
            this.toastErrorMessage(error, `${type}TO`);
            await MyJobsActions.getMyJobs("ALL");
            return "ERROR";
        }
    };

    delayRefreshFoldersList = (delay) => {
        const { sources } = this.props;
        const hierarchy = sources.hierarchy;
        const hierarchyActive = "folder";
        setTimeout(() => {
            this.refreshFolderList(hierarchy[hierarchyActive].selected);
        }, delay || 1000);
    };

    onChangeFoldersMoveToItems = async (folder, targets, option) => {
        if (throttleHandler) {
            return;
        }
        const { SourcesActions, MyJobsActions } = this.props;
        const { bucketPath } = this.state;
        const bucketName = folder.bucketName;
        const folderPath = bucketPath.folderPath ? `/${bucketPath.folderPath}` : "";
        let to = folder.type === "bucket" ? `${bucketName}/` : `${bucketName}/${folder.path}`;
        const items = targets.map((item) => {
            return {
                path: `${folderPath}/${item.path}`,
                isFolder: item.isFolder,
            };
        });
        try {
            throttleHandler = true;
            if (option === "NONE") {
                const response = await SourcesActions.validationSources(bucketPath.bucket, "MOVE", to, items);
                const { data } = response;
                if (data) {
                    const validatedItems = data.from.items || [];
                    const passParams = {
                        bucketName,
                        to,
                        type: "MOVE",
                    };
                    for (let item of validatedItems) {
                        if (item.duplicated === true) {
                            return this.setIsShowCheckSourcesModal(true, validatedItems, passParams);
                        }
                    }
                    const noDuplicatedItems = validatedItems.map((item) => {
                        item.option = "OVERWRITE";
                        return item;
                    });
                    // TODO: Max request payload size: 262144
                    const response = await SourcesActions.moveSources(
                        bucketPath.bucket,
                        to,
                        noDuplicatedItems,
                        null,
                        true,
                    );
                    // const { jobId } = response.data;

                    // this.setShowModal("MOVETO", false);
                    // this.afterMutationWorks("Move to", jobId);

                    // const status = await this.startPollingJobStatus(jobId);
                    // if (status === "FAILED") {
                    //     // this.toastJustMessage('error', 'Move to excution failed.')
                    //     throw new Error("Move to error.");
                    // }
                    return response;
                }
            } else {
                const response = await SourcesActions.moveSources(bucketPath.bucket, to, items, option);
                // const { jobId } = response.data;
                // this.setShowModal("MOVETO", false);
                // this.afterMutationWorks("Move to", jobId);

                // const status = await this.startPollingJobStatus(jobId);
                // if (status === "FAILED") {
                //     // this.toastJustMessage('error', 'Move to excution failed.')
                //     throw new Error("Move to error.");
                // }
                return response;
            }
        } catch (error) {
            this.toastErrorMessage(error, "MOVETO");
            await MyJobsActions.getMyJobs("ALL");
            throw error;
        } finally {
            this.clearThrottleHandler();
        }
    };

    clearThrottleHandler = () => {
        throttleHandler = false;
    };

    cancelToValidationWork = () => {
        this.clearThrottleHandler();
        this.setIsShowCheckSourcesModal(false, null, null, {
            resetValidateModal: true,
        });
        setTimeout(() => {
            this.setState({
                ...this.state,
                resetValidateModal: false,
            });
        }, 500);
    };

    onChangeFoldersCopyToItems = async (folder, targets, option) => {
        if (throttleHandler) {
            return;
        }
        const { SourcesActions, MyJobsActions } = this.props;
        const { bucketPath } = this.state;
        const bucketName = folder.bucketName;
        const folderPath = bucketPath.folderPath ? `/${bucketPath.folderPath}` : "";
        let to = folder.type === "bucket" ? `${bucketName}/` : `${bucketName}/${folder.path}`;
        const items = targets.map((item) => {
            return {
                path: `${folderPath}/${item.path}`,
                isFolder: item.isFolder,
            };
        });
        try {
            throttleHandler = true;
            if (option === "NONE") {
                const response = await SourcesActions.validationSources(bucketPath.bucket, "COPY", to, items);
                const { data } = response;
                if (data) {
                    const validatedItems = data.from.items || [];
                    const passParams = {
                        bucketName,
                        to,
                        type: "COPY",
                    };
                    for (let item of validatedItems) {
                        if (item.duplicated === true) {
                            this.setIsShowCheckSourcesModal(true, validatedItems, passParams);
                            return;
                        }
                    }
                    const noDuplicatedItems = validatedItems.map((item) => {
                        item.option = "OVERWRITE";
                        return item;
                    });
                    // TODO: Max request payload size: 262144
                    const response = await SourcesActions.copySources(
                        bucketPath.bucket,
                        to,
                        noDuplicatedItems,
                        null,
                        true,
                    );
                    // const { jobId } = response.data;
                    // const status = await this.startPollingJobStatus(jobId);
                    // if (status === "FAILED") {
                    //     // this.toastJustMessage('error', 'Copy to excution failed.')
                    //     throw new Error("Copy to error.");
                    // }
                    return response;
                }
            } else {
                const response = await SourcesActions.copySources(bucketPath.bucket, to, items, option);
                // const { jobId } = response.data;
                // const status = await this.startPollingJobStatus(jobId);
                // if (status === "FAILED") {
                //     // this.toastJustMessage('error', 'Copy to excution failed.')
                //     throw new Error("Copy to error.");
                // }
                return response;
            }
        } catch (error) {
            this.toastErrorMessage(error, "COPYTO");
            await MyJobsActions.getMyJobs("ALL");
            throw error;
        } finally {
            this.clearThrottleHandler();
        }
    };

    setShowModal = (actionType, flag) => {
        if (actionType === "NEWFOLDER" && compareVersions(this.props.stage.version, VERSION_SOURCE_VIEW_MUTATION) < 0) {
            return;
        }

        let newState = {};
        switch (actionType) {
            case "RENAME":
                newState.isShowRenameModal = flag;
                break;
            case "MOVETO":
                newState.isShowMoveToModal = flag;
                break;
            case "COPYTO":
                newState.isShowCopyToModal = flag;
                break;
            case "DELETE":
                newState.isShowDeleteConfirmModal = flag;
                break;
            case "NEWFOLDER":
                newState.isShowNewFolderModal = flag;
                break;
            case "DOWNLOADLINK":
                newState.isShowDownloadLinkModal = flag;
                break;
        }
        if (flag === false) {
            newState.actionTarget = null;
        }
        this.setState({
            ...this.state,
            ...newState,
        });
    };

    onClickOutsideDropdown = () => {
        this.setState({
            ...this.state,
            dropDownTarget: null,
        });
    };

    onValidation = async (targets, newName) => {
        if (throttleHandler) {
            return;
        }
        const { SourcesActions } = this.props;
        const { bucketPath } = this.state;
        const bucketName = bucketPath.bucket;
        const folderPath = bucketPath.folderPath ? `/${bucketPath.folderPath}` : "";
        let to = `${bucketName}${folderPath}/${newName}`;
        const items = targets.map((item) => {
            return {
                path: `${folderPath}/${item.path}`,
                isFolder: item.isFolder,
            };
        });
        try {
            throttleHandler = true;
            const response = await SourcesActions.validationSources(bucketName, "RENAME", to, items);
            const { data } = response;
            const checkedItems = data.from.items || [];
            this.clearThrottleHandler();
            return checkedItems;
        } catch (error) {
            this.toastErrorMessage(error, "VALIDATION");
            this.clearThrottleHandler();
            throw error;
        }
    };

    onClickCreateNewFolder = async (folderName) => {
        if (throttleHandler) {
            return;
        }

        const { SourcesActions, MyJobsActions } = this.props;
        const { bucketPath } = this.state;
        const bucketName = bucketPath.bucket;
        const folderPath = bucketPath.folderPath ? `/${bucketPath.folderPath}` : "";
        const items = [
            {
                path: `${folderPath}/${folderName}`,
                isFolder: true,
            },
        ];

        try {
            throttleHandler = true;
            const response = await SourcesActions.createFolder(bucketName, items);
            this.clearThrottleHandler();
            return response;
        } catch (error) {
            this.toastErrorMessage(error, "NEWFOLDER");
            this.clearThrottleHandler();
            await MyJobsActions.getMyJobs("ALL");
            throw error;
        }
    };

    onClickCreateNewFolders = async (folders, prefix, extendPath, needRefresh) => {
        // NOTE: TreeView에서 드래그엔 드롭 하는 경우에는 prefix를 넘겨주고, folderList에서는 extendPath를 넘겨준다.
        if (throttleHandler) {
            return;
        }

        const { SourcesActions, MyJobsActions } = this.props;
        const { bucketPath } = this.state;
        const bucketName = bucketPath.bucket;

        let _prefix = prefix;
        if (!_prefix) {
            if (extendPath) {
                const item = this.props.sources.hierarchy.folder.selected.children.find(
                    (item) => `/${item.name}` === extendPath,
                );
                _prefix = item.prefix;
            } else {
                _prefix = this.props.sources.hierarchy.folder.selected.prefix;
            }
        }
        const items = folders.map((f) => ({ path: `/${_prefix}${f.path}`, isFolder: true }));

        try {
            throttleHandler = true;
            const response = await SourcesActions.createFolder(bucketName, items);
            this.clearThrottleHandler();
            return response;
        } catch (error) {
            this.toastErrorMessage(error, "NEWFOLDER");
            this.clearThrottleHandler();
            await MyJobsActions.getMyJobs("ALL");
            throw error;
        } finally {
            const hierarchy = this.props.sources.hierarchy;
            if (needRefresh) this.refreshFolderList(hierarchy.folder.selected);
        }
    };

    toastJustMessage = (type, message) => {
        const { NotificationActions } = this.props;
        NotificationActions.setNotification({
            type,
            contents: `${message}`,
        });
    };

    toastErrorMessage = (error, actionType) => {
        const { NotificationActions } = this.props;
        const errorStatus = error.response && error.response.status;
        if (errorStatus === 400) {
            const errorMessage = error.response.data && error.response.data.message;
            switch (actionType) {
                case "NEWFOLDER":
                    if (
                        error.response &&
                        error.response.data.code !== 6002 &&
                        error.response &&
                        error.response.data.code !== 6001
                    ) {
                        NotificationActions.setNotification({
                            type: "error",
                            contents: `[Error:${errorStatus}] => ${errorMessage}`,
                        });
                    }
                    break;
                case "VALIDATION":
                    if (error.response && error.response.data.code !== 6001) {
                        NotificationActions.setNotification({
                            type: "info",
                            contents: errorMessage,
                        });
                    }
                    break;
                case "RENAME":
                case "DELETE":
                case "MOVETO":
                case "COPYTO":
                    if (error?.response?.data?.code === 6009) {
                        // 파일이 너무 많아 일일이 확인하기 어려우니 한 번에 덮어쓸지 스킵할지 고르도록 유도
                        NotificationActions.setNotification({
                            type: "info",
                            contents: errorMessage,
                        });
                    } else {
                        NotificationActions.setNotification({
                            type: "error",
                            contents: `[Error:${errorStatus}] => ${errorMessage}`,
                        });
                    }
                    break;
            }
        } else if (errorStatus === 409) {
            // 다른 사람이 버킷을 잠근 상태일 때
            NotificationActions.setNotification({
                type: "info",
                contents: <BucketLockInfoMessage />,
            });
        } else {
            this.toastJustMessage("error", error ? error : "Unknown server error occured.");
        }
    };

    toastInfoMessage = (keys, isDirectDownloadRequest) => {
        const { NotificationActions } = this.props;
        const { selectedItems, bucketPath } = this.state;
        const { bucket, folderPath } = bucketPath;

        NotificationActions.setNotification({
            type: "info",
            autoClose: false,
            contents: (
                <DownloadInfoMessage
                    folders={[`${bucket}/${folderPath}`]}
                    fileName={keys[0].slice(1)}
                    totalCount={keys.length}
                    isDirectDownloadMissMatchRegion={isDirectDownloadRequest}
                />
            ),
        });
    };

    createAssets = (targetList) => {
        this.setState({ isAssetCreating: true });
        const { dispatch } = this.props;
        const { selectedItems, bucketPath } = this.state;
        const createAssets = selectedItems.map((item) => {
            const url = `s3://${bucketPath.bucket}/${join(bucketPath.folderPath, item.path)}`;
            const urlInfo = getUrlInfo(item.path);
            const asset = {
                mediaType: urlInfo.mediaType,
                type: urlInfo.type,
                ingestType: INGEST_TYPE.REMOTE,
                name: item.path.replace(/\.[a-zA-Z0-9]+$/, ""),
                elements: [
                    {
                        locationType: UPLOAD_FILE_LOCATION_TYPE.S3,
                        displayName: item.path.replace(/\.[a-zA-Z0-9]+$/, ""),
                        mimeType: urlInfo.mimeType,
                    },
                ],
            };
            if (urlInfo.mediaType === MEDIA_TYPES.VIDEO || urlInfo.mediaType === MEDIA_TYPES.AUDIO)
                asset.elements[0].urls = [url];
            else if (urlInfo.mediaType === MEDIA_TYPES.CAPTION) {
                asset.type = "SUBTITLE";
                asset.elements[0].url = url;
                asset.elements[0].label = "undefined";
                asset.elements[0].language = "undefined";
                asset.elements[0].country = "undefined";
                asset.elements[0].kind = "SUBTITLE";
            } else asset.elements[0].url = url;
            return asset;
        });
        const ps = createAssets.map((a) => {
            return dispatch(createAssetActions.createAsset(a, true))
                .then((response) => {
                    this.toastJustMessage("success", `Asset(${fp.get("name", a)}) Create Completed.`);
                    return response;
                })
                .catch((error) => {
                    console.error("create fail error", error);
                    this.toastJustMessage("error", `Asset(${fp.get("name", a)}) Create Failed.`);
                    return error;
                });
        });
        this.createAssetsPromise = Promise.allSettled(ps)
            .finally(() => {
                this.setState({ isAssetCreating: false, selectedItems: [], isChecked: false });
            })
            .then((results) => {
                results.map((result) => {
                    console.debug("result:", result);
                });
            });
    };

    onClickViewMore = () => {
        const pageCount = this.state.tokenPaginationInfo.data.length;
        const lastPageInfo = this.state.tokenPaginationInfo.data[pageCount - 1];

        const offset = pageCount * this.props.sources.search.defaultViewCountByToken;
        this.onSubmitForm({ offset }, lastPageInfo.nextToken, false, this.state.tokenPaginationInfo);
        // this.setState({
        //     ...this.state,
        //     tokenPaginationInfo
        // })
    };

    onChangeOffsetWithToken = (page) => {
        const prevPage = this.state.tokenPaginationInfo.data.find((v) => v.page === page - 1);

        const token = prevPage ? prevPage.nextToken : "";

        const offset = (page - 1) * this.props.sources.search.defaultViewCountByToken;
        this.onSubmitForm({ offset }, token, true, this.state.tokenPaginationInfo);
    };

    onClickDownload = async () => {
        const { settings } = this.props;

        const settingShouldZipFileCount = settings?.stage?.Storage?.shouldZipFileCount?.value;
        const shouldZipFileCount = settingShouldZipFileCount ? parseInt(settingShouldZipFileCount) : 5;

        if (throttleHandler) return;

        const { selectedItems, bucketPath } = this.state;
        const { bucket, folderPath } = bucketPath;
        const prefix = folderPath.length === 0 ? `/${folderPath}` : `/${folderPath}/`;
        const keys = selectedItems.map((item) => `${prefix}${item.isFolder ? `${item.path}/` : item.path}`);
        const options = {
            shouldZip: selectedItems.find((v) => v.isFolder) || keys.length > shouldZipFileCount ? true : false,
        };
        await this.createDownloadJob(bucket, keys, "S3", options);
    };

    createDownloadJob = async (bucket, keys, provider, options) => {
        const { stage, DownloadJobsActions } = this.props;

        try {
            throttleHandler = true;
            const response = await DownloadJobsActions.createDownloadJob(
                "STORAGE",
                [{ bucket, keys, provider }],
                options,
            );
            const jobId = response?.data?.id;
            const jobStatus = response?.data?.status;
            const isDirectDownloadRequest =
                compareVersions(stage.version, VERSION_CM_12198_COLLECTION_DOWNLOAD) >= 0
                    ? response?.data?.metadata?.isRegionMisMatched
                    : response?.data?.metadata?.isDirectDownloadRequest === "MISS_MATCH_REGION";

            this.toastInfoMessage(keys, isDirectDownloadRequest);

            this.clearThrottleHandler();
            this.uncheckAllSelectBoxes();
            await DownloadJobsActions.getDownloadJobs([jobId]);
        } catch (error) {
            console.log(error);
            this.clearThrottleHandler();
        }
    };

    uncheckAllSelectBoxes = () => {
        this.setState({
            ...this.state,
            selectedItems: [],
            isChecked: false,
        });
    };

    onClickRow = async (data) => {
        const { PropertyPanelActions, sources } = this.props;
        const selectedFolder =
            sources?.hierarchy?.folder?.selected?.type === "bucket" ? "" : sources?.hierarchy?.folder?.selected?.name;

        const fileType = getMediaTypeFromExtension(data.path.slice(data.path.lastIndexOf(".")));
        const prefix = sources?.hierarchy?.folder?.selected?.prefix;
        const bucket = sources?.hierarchy?.folder?.history?.navView[0].name;

        const clickStorageData = {
            name: data.path,
            bucket: bucket,
            prefix: prefix,
            size: data.size,
            isFolder: data.isFolder,
            storageClass: data.storageClass,
            lastModified: data.lastModified,
            mediaType: [MEDIA_TYPES.AUDIO, MEDIA_TYPES.IMAGE, MEDIA_TYPES.VIDEO].includes(fileType) ? fileType : "FILE",
            extension: data.path.slice(data.path.lastIndexOf(".") + 1),
        };

        PropertyPanelActions.togglePropertyPanel({
            targetId: `${selectedFolder}_${data.path}`,
            type: PROPERTY_PANEL_TYPE.STORAGE,
            data: clickStorageData,
        });
    };

    onClickToggleExpandQuickSearchField = () => {
        this.setState({
            ...this.state,
            isQuickSearch: !this.state.isQuickSearch,
        });
    };

    displayPathList = (pathItems) => {
        const array = [];
        for (let i = 1; i < pathItems.length - 1; i++) {
            const item = pathItems[i];

            array.push(<button onClick={() => this.onClickTreePath(item)}>{item.name}</button>);
        }

        return (
            <>
                {array.map((button, i) => {
                    return button;
                })}
            </>
        );
    };

    onChangeBucketLock = (item) => {
        const { SourcesActions, sources } = this.props;

        const newHierarchy = sources.hierarchy.folder.data.map((d) => {
            if (d.id === item.id) {
                if (item.isLocked)
                    return { ...d, isLocked: item.isLocked, lockedBy: item.lockedBy, lockedAt: item.lockedAt };
                else return { ...d, isLocked: item.isLocked, lockedBy: null, lockedAt: null };
            } else return d;
        });

        const newNavView = sources.hierarchy.folder.history?.navView;

        if (item.id === newNavView[0]?.id) {
            if (item.isLocked) {
                newNavView[0] = {
                    ...newNavView[0],
                    isLocked: item.isLocked,
                    lockedBy: item.lockedBy,
                    lockedAt: item.lockedAt,
                };
            } else {
                newNavView[0] = {
                    ...newNavView[0],
                    isLocked: item.isLocked,
                    lockedBy: null,
                    lockedAt: null,
                };
            }
        }

        const data = {
            ...sources,
            hierarchy: {
                ...sources.hierarchy,
                folder: {
                    ...sources.hierarchy.folder,
                    data: newHierarchy,
                    history: {
                        ...sources.hierarchy.folder.history,
                        navView: newNavView,
                    },
                },
            },
        };

        SourcesActions.updateState(data);
    };

    treeRef = React.createRef();

    render = () => {
        const { stage, sources, t, CreateAssetsBulkActions, createAssetsBulk } = this.props;
        const hierarchy = sources.hierarchy;
        const hierarchyActive = "folder";
        const { STORAGES_PERMISSIONS } = this.props.checkedPermissions;

        const folderList = ((sources && sources.objects) || []).filter((o) => o.isFolder);
        const fileList = ((sources && sources.objects) || []).filter((o) => !o.isFolder);

        const total = ((sources && sources.objects) || []).length;
        const {
            pending,
            selectedItems,
            isChecked,
            isShowCopyToModal,
            isShowMoveToModal,
            isShowDeleteConfirmModal,
            actionTarget,
            dropDownTarget,
            isShowRenameModal,
            isShowCheckSourcesModal,
            isShowDownloadLinkModal,
            validationFiles,
            isShowNewFolderModal,
            bucketPath,
            isLockedByMeOrUnLocked,
        } = this.state;

        const { bucket, folderPath } = bucketPath || {};

        const mutationDisable = this.state.bucketPath ? this.state.bucketPath.uploadDisabled : true;
        const mutationDownloadDisable = this.state.bucketPath ? this.state.bucketPath.downloadDisabled : true;

        const hideContents = stage && stage.extensions && stage.extensions["HIDE_CONTENTS"] === "true";

        return (
            <React.Fragment>
                <VersionedComponent version={VERSION_SOURCE_VIEW_MUTATION}>
                    {/* 복사 */}
                    {isShowCopyToModal
                        ? ReactDOM.createPortal(
                              <LoadableSelectStorageModal
                                  submitText={`Copy`}
                                  title={`Copy to`}
                                  onClose={() => {
                                      this.setShowModal("COPYTO", false);
                                  }}
                                  onSubmit={this.onChangeFoldersCopyToItems}
                                  mutationDisable={mutationDisable}
                                  mutationDownloadDisable={mutationDownloadDisable}
                                  bucketPath={this.state.bucketPath}
                                  selectedItems={actionTarget ? [actionTarget] : selectedItems}
                                  afterMutationWorks={this.afterMutationWorks}
                                  resetValidateModal={this.state.resetValidateModal}
                                  startPollingJobStatus={this.startPollingJobStatus}
                                  getBucketLockIcon={this.getBucketLockIcon}
                              />,
                              document.body,
                          )
                        : ""}
                    {/* 이동 */}
                    {isShowMoveToModal &&
                        ReactDOM.createPortal(
                            <LoadableSelectStorageModal
                                submitText={`Move`}
                                title={`Move`}
                                onClose={() => {
                                    this.setShowModal("MOVETO", false);
                                }}
                                onSubmit={this.onChangeFoldersMoveToItems}
                                mutationDisable={mutationDisable}
                                bucketPath={this.state.bucketPath}
                                selectedItems={actionTarget ? [actionTarget] : selectedItems}
                                afterMutationWorks={this.afterMutationWorks}
                                resetValidateModal={this.state.resetValidateModal}
                                startPollingJobStatus={this.startPollingJobStatus}
                                getBucketLockIcon={this.getBucketLockIcon}
                            />,
                            document.body,
                        )}
                    {/* 삭제 */}
                    {isShowDeleteConfirmModal &&
                        ReactDOM.createPortal(
                            <LoadableDeleteModal
                                active={isShowDeleteConfirmModal}
                                selectedItems={actionTarget ? [actionTarget] : selectedItems}
                                onClickClose={() => {
                                    this.setShowModal("DELETE", false);
                                }}
                                onClickDelete={this.onClickDeleteSources}
                                afterMutationWorks={this.afterMutationWorks}
                            />,
                            document.body,
                        )}
                    {/* 이름 변경 */}
                    {isShowRenameModal &&
                        ReactDOM.createPortal(
                            <LoadableRenameModal
                                selectedItems={actionTarget ? [actionTarget] : selectedItems}
                                onClickClose={() => {
                                    this.setShowModal("RENAME", false);
                                }}
                                onClickSubmit={this.onClickRenameSource}
                                onValidation={this.onValidation}
                                afterMutationWorks={this.afterMutationWorks}
                            />,
                            document.body,
                        )}
                    {/* 중복 확인 */}
                    {isShowCheckSourcesModal &&
                        ReactDOM.createPortal(
                            <LoadableCheckSourcesModal
                                active={isShowCheckSourcesModal}
                                validationFiles={validationFiles}
                                onClickClose={() => {
                                    this.clearThrottleHandler();
                                    this.setIsShowCheckSourcesModal(false);
                                }}
                                onClickSubmit={this.afterCheckSubmit}
                                afterMutationWorks={this.afterMutationWorks}
                                cancelToValidationWork={this.cancelToValidationWork}
                                startPollingJobStatus={this.startPollingJobStatus}
                            />,
                            document.body,
                        )}
                    {/*  다운로드 링크 */}
                    {isShowDownloadLinkModal &&
                        ReactDOM.createPortal(
                            <LoadableDownloadLinkModal
                                domain={"STORAGE"}
                                selectedItems={
                                    this.state.actionTarget
                                        ? [
                                              {
                                                  bucket: bucket,
                                                  key: `${folderPath ? `${folderPath}/` : ""}${
                                                      this.state.actionTarget.isFolder
                                                          ? `${this.state.actionTarget.path}/`
                                                          : this.state.actionTarget.path
                                                  }`,
                                              },
                                          ]
                                        : this.state.selectedItems.map((item) => {
                                              return {
                                                  ...item,
                                                  bucket: bucket,
                                                  key: `${folderPath ? `${folderPath}/` : ""}${
                                                      item.isFolder ? `${item.path}/` : item.path
                                                  }`,
                                              };
                                          })
                                }
                                onClickClose={() => this.setIsShowDownloadLinkModal(false)}
                            />,
                            document.body,
                        )}
                </VersionedComponent>
                <VersionedComponent version={VERSION_SOURCE_VIEW_NEW_FOLDER}>
                    {/* 새폴더 */}
                    {isShowNewFolderModal &&
                        ReactDOM.createPortal(
                            <LoadableNewFolderModal
                                onClickClose={() => {
                                    this.setShowModal("NEWFOLDER", false);
                                }}
                                onClickSubmit={this.onClickCreateNewFolder}
                                afterMutationWorks={this.afterMutationWorks}
                            />,
                            document.body,
                        )}
                </VersionedComponent>
                {sources.error || !STORAGES_PERMISSIONS?.READ ? (
                    <AccessDenied />
                ) : (
                    <>
                        <DuplicateCheckModal ref={duplicateModalRef} />

                        {this.state.isActiveModal.folder &&
                            ReactDOM.createPortal(
                                <LoadableFolderSelectModal
                                    selectedLocationType={"Local"}
                                    addSelectedFiles={this.onSelectFilesUpload}
                                    maximumSize={"5 TB"}
                                    acceptFileExtension={["*"]}
                                    isMultiFileSelect={true}
                                    isShowDuplicationActionPannel={true}
                                    onlyLocal={true}
                                    bucketPath={this.state.bucketPath}
                                    onClose={() => this.onClickToggleModal("folder")}
                                />,
                                document.body,
                            )}
                        {this.state.isActiveModal.files &&
                            ReactDOM.createPortal(
                                <LoadableFileSelectModal
                                    selectedLocationType={"Local"}
                                    addSelectedFiles={this.onSelectFilesUpload}
                                    maximumSize={"5 TB"}
                                    acceptFileExtension={["*"]}
                                    isMultiFileSelect={true}
                                    isShowDuplicationActionPannel={true}
                                    onlyLocal={true}
                                    bucketPath={this.state.bucketPath}
                                    onClose={() => this.onClickToggleModal("files")}
                                />,
                                document.body,
                            )}

                        <PageHeader
                            title={<Typography variant={"h3"}>{t(`common::label::Storage`)}</Typography>}
                            breadcrumb={<BreadcrumbsWithRouterPath />}
                        />

                        <PageTools
                            search={
                                <form
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        this.props.SourcesActions.updateSearch({
                                            name: sources.search.keyword,
                                        });
                                        this.setState((prevState) => ({
                                            ...prevState,
                                            advanceSearchKeyword: sources.search.keyword,
                                        }));
                                        this.onSubmitForm({ offset: 0 });
                                        this.searchRef.current.blur();
                                    }}
                                >
                                    <Grid container>
                                        <Grid item xs={6}>
                                            {compareVersions(stage.version, VERSION_CM_8667_STORAGE_V3) >= 0 ? (
                                                <TextField
                                                    ref={this.searchRef}
                                                    type={"search"}
                                                    variant={"filled"}
                                                    fullWidth
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <IconSearch size={16} color={"greySecondary"} />
                                                            </InputAdornment>
                                                        ),
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                {compareVersions(
                                                                    stage.version,
                                                                    VERSION_CM_8667_STORAGE_V3,
                                                                ) < 0 && (
                                                                    <Tooltip
                                                                        title={i18n.t(
                                                                            `common::label::${"Advanced search"}`,
                                                                        )}
                                                                    >
                                                                        <IconButton
                                                                            circled
                                                                            size={"medium"}
                                                                            onClick={(e) => {
                                                                                this.onClickToggleExpandQuickSearchField();
                                                                            }}
                                                                        >
                                                                            <IconTune
                                                                                size={20}
                                                                                htmlColor={theme.palette.secondary[500]}
                                                                            />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                )}
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                    name={"username"}
                                                    placeholder={t(
                                                        `common::label::Find objects by prefix`,
                                                        `Find objects by prefix`,
                                                    )}
                                                    value={sources.search.keyword}
                                                    onChange={(e) => {
                                                        this.props.SourcesActions.updateSearch({
                                                            keyword: e.target.value,
                                                        });
                                                    }}
                                                />
                                            ) : (
                                                <TextField
                                                    ref={this.searchRef}
                                                    type={"search"}
                                                    variant={"filled"}
                                                    fullWidth
                                                    name={"username"}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <IconSearch size={16} color={"greySecondary"} />
                                                            </InputAdornment>
                                                        ),
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                {compareVersions(
                                                                    stage.version,
                                                                    VERSION_CM_8667_STORAGE_V3,
                                                                ) < 0 && (
                                                                    <Tooltip
                                                                        title={i18n.t(
                                                                            `common::label::${"Advanced search"}`,
                                                                        )}
                                                                    >
                                                                        <IconButton
                                                                            circled
                                                                            size={"medium"}
                                                                            onClick={(e) => {
                                                                                this.onClickToggleExpandQuickSearchField();
                                                                            }}
                                                                        >
                                                                            <IconTune
                                                                                size={20}
                                                                                htmlColor={theme.palette.secondary[500]}
                                                                            />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                )}
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                    placeholder={t(`common::label::Search`, `Search`)}
                                                    value={sources.search.keyword}
                                                    onChange={(e) => {
                                                        this.props.SourcesActions.updateSearch({
                                                            keyword: e.target.value,
                                                        });
                                                    }}
                                                />
                                            )}
                                        </Grid>

                                        <Popover
                                            anchorEl={this.searchRef.current}
                                            open={!this.state.isQuickSearch}
                                            onClose={() => {
                                                this.setState({ ...this.state, isQuickSearch: true });
                                            }}
                                            anchorOrigin={{
                                                vertical: "bottom",
                                                horizontal: "left",
                                            }}
                                            transformOrigin={{
                                                vertical: "top",
                                                horizontal: "left",
                                            }}
                                            sx={{
                                                ".MuiPaper-root": {
                                                    padding: 3,
                                                    width: this.searchRef.current
                                                        ? getComputedStyle(this.searchRef.current).width
                                                        : "100%",
                                                    boxShadow: `0 3px 6px 0 rgba(0, 0, 0, 0.16)`,
                                                    border: `1px solid ${theme.palette.secondary[600]}`,
                                                    boxSizing: `border-box`,
                                                },
                                            }}
                                        >
                                            <Grid container alignItems={"flex-start"}>
                                                <Grid item xs>
                                                    <Box
                                                        sx={{
                                                            display: `flex`,
                                                            flexDirection: `column`,
                                                            maxHeight: `70vh`,
                                                            overflowY: `auto`,
                                                            paddingRight: 2.5,
                                                        }}
                                                        gap={2}
                                                    >
                                                        <Stack>
                                                            <Grid container alignItems={"center"}>
                                                                <Grid item xs={3}>
                                                                    <Typography variant={"body1_400"}>
                                                                        {t(`common::label::Name`)}
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs>
                                                                    <input
                                                                        type={"text"}
                                                                        className={"form-control form-control"}
                                                                        name={"username"}
                                                                        placeholder={t(
                                                                            `common::label::Enter Name`,
                                                                            `Enter Name`,
                                                                        )}
                                                                        value={this.state.advanceSearchKeyword}
                                                                        onChange={(e) => {
                                                                            this.setState({
                                                                                ...this.state,
                                                                                advanceSearchKeyword: e.target.value,
                                                                            });
                                                                        }}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Stack>
                                                        <Stack>
                                                            <Grid container alignItems={"center"}>
                                                                <Grid item xs={3}>
                                                                    <Typography variant={"body1_400"}>
                                                                        {t(`common::label::Storage Class`)}
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs>
                                                                    <WithSelect
                                                                        defaultValue={sources.search.storageClass}
                                                                        placeholder={t(
                                                                            `common::label::All Storage Class`,
                                                                            `All Storage Class`,
                                                                        )}
                                                                        onChange={(option) => {
                                                                            this.props.SourcesActions.updateSearch({
                                                                                storageClass: option.value,
                                                                            });
                                                                        }}
                                                                        options={CONSTANTS("S3_STORAGE_CLASS")}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Stack>
                                                        <Stack>
                                                            <Grid container alignItems={"center"}>
                                                                <Grid item xs={3}>
                                                                    <Typography variant={"body1_400"}>
                                                                        {t(`common::label::Last Modified`)}
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs>
                                                                    <RangePicker
                                                                        startDate={sources.search.beginDate}
                                                                        endDate={sources.search.endDate}
                                                                        isOutsideRange={() => false}
                                                                        onDatesChange={({ startDate, endDate }) => {
                                                                            this.props.SourcesActions.updateSearch({
                                                                                beginDate: startDate,
                                                                                endDate,
                                                                            });
                                                                        }}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Stack>
                                                    </Box>
                                                    <Divider sx={{ mt: 3, mb: 3 }} />
                                                    <Grid container alignItems={"center"} justifyContent={"flex-end"}>
                                                        <Button
                                                            variant={"text"}
                                                            size={"medium"}
                                                            color={"greySecondary"}
                                                            onClick={(e) => {
                                                                this.onClickReset();
                                                            }}
                                                        >
                                                            {i18n.t(`common::label::Reset`)}
                                                        </Button>
                                                        <Button
                                                            variant={"contained"}
                                                            color={"primary"}
                                                            type={"submit"}
                                                            size={"medium"}
                                                            sx={{ ml: 0.75 }}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                this.props.SourcesActions.updateSearch({
                                                                    keyword: this.state.advanceSearchKeyword,
                                                                });
                                                                this.onSubmitForm({ offset: 0 });
                                                            }}
                                                        >
                                                            {t(`common::label::Search`, `Search`)}
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title={t(`common::label::Close`, `Close`)}>
                                                        <IconButton
                                                            type={"button"}
                                                            size={"medium"}
                                                            circled
                                                            onClick={() =>
                                                                this.setState({
                                                                    ...this.state,
                                                                    isQuickSearch: true,
                                                                })
                                                            }
                                                        >
                                                            <IconClose size={16} color={"greySecondary"} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Grid>
                                            </Grid>
                                        </Popover>
                                    </Grid>
                                </form>
                            }
                        />

                        <Divider flexItem />

                        <Grid
                            container
                            sx={{ flex: 1, overflow: `hidden`, position: `relative` }}
                            flexWrap={"nowrap"}
                            gap={3}
                        >
                            <Grid item sx={{ minWidth: 64 }}>
                                <TreeView
                                    anchorRef={this.treeRef}
                                    onClickTree={this.onClickTree}
                                    onClickTreePath={this.onClickTreePath}
                                    treeData={sources.hierarchy}
                                    type={"buckets"}
                                    bucketPath={this.state.bucketPath}
                                    pendingItem={sources.pending}
                                    onDropTreeFile={this.onDropTreeFile}
                                    onDropDisabled={this.onDropDisabled}
                                    fileUploadable={true}
                                    stage={this.props.stage}
                                    activeView={"Sources"}
                                    onChangeBucketLock={this.onChangeBucketLock}
                                    getBucketLockIcon={this.getBucketLockIcon}
                                    isShowBucketLockSetting={true}
                                    onCreateNewFolders={this.onClickCreateNewFolders}
                                />
                            </Grid>
                            <Grid
                                item
                                xs
                                pt={1.5}
                                sx={{ display: `flex`, flexDirection: `column`, overflow: `hidden` }}
                                onDragOver={(e) => {
                                    e.stopPropagation();
                                    e.dataTransfer.dropEffect = "move";
                                }}
                                onDragLeave={(e) => {
                                    e.stopPropagation();
                                }}
                            >
                                <Grid container flexDirection={"column"} gap={1.5}>
                                    <Grid item>
                                        <Grid container alignItems={"center"} justifyContent={"space-between"}>
                                            <Grid item>
                                                <Grid container alignItems={"center"}>
                                                    <Grid item>
                                                        <Tooltip title={t(`common::label::Previous`, `Previous`)}>
                                                            <IconButton
                                                                circled
                                                                type="button"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    this.onClickNavPrev();
                                                                }}
                                                                disabled={
                                                                    hierarchy.pending ||
                                                                    !hierarchy[hierarchyActive].history ||
                                                                    (hierarchy[hierarchyActive] &&
                                                                        hierarchy[hierarchyActive].history &&
                                                                        hierarchy[hierarchyActive].history.index < 1)
                                                                }
                                                            >
                                                                <IconArrowBack size={16} />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title={t(`common::label::Next`, `Next`)}>
                                                            <IconButton
                                                                circled
                                                                type="button"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    this.onClickNavNext();
                                                                }}
                                                                disabled={
                                                                    hierarchy.pending ||
                                                                    !hierarchy[hierarchyActive].history ||
                                                                    (hierarchy[hierarchyActive] &&
                                                                        hierarchy[hierarchyActive].history &&
                                                                        hierarchy[hierarchyActive].history.index ===
                                                                            hierarchy[hierarchyActive].history.items
                                                                                .length -
                                                                                1)
                                                                        ? true
                                                                        : false
                                                                }
                                                            >
                                                                <IconArrowForward size={16} />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title={t(`common::label::Parent folder`, `Parent folder`)}>
                                                            <IconButton
                                                                circled
                                                                type="button"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    this.onClickUpperPath();
                                                                }}
                                                                disabled={
                                                                    hierarchy.pending ||
                                                                    !hierarchy[hierarchyActive].history ||
                                                                    hierarchy[hierarchyActive]?.selected?.code.split("_")
                                                                        .length < 2
                                                                }
                                                            >
                                                                <IconUp size={16} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Grid>
                                                    <Grid item>
                                                        <Grid container alignItems={"center"}>
                                                            <Breadcrumbs separator={<IconSeparator size={8} />}>
                                                                {hierarchy[hierarchyActive]?.history?.navView?.length
                                                                    ? hierarchy[hierarchyActive].history.navView.map(
                                                                          (item, index) => (
                                                                              <Grid item key={item.id}>
                                                                                  {index === 0 ? (
                                                                                      <>
                                                                                          {item.indexingState ===
                                                                                              "FAILED" &&
                                                                                              item.indexingState ===
                                                                                                  "PROCESSING" && (
                                                                                                  <StorageSyncTooltip
                                                                                                      indexingState={
                                                                                                          item.indexingState
                                                                                                      }
                                                                                                      indexingRequestedAt={
                                                                                                          item.indexingRequestedAt
                                                                                                      }
                                                                                                      indexingCompletedAt={
                                                                                                          item.indexingCompletedAt
                                                                                                      }
                                                                                                  />
                                                                                              )}
                                                                                          {this.getBucketLockIcon(item)}
                                                                                          <Button
                                                                                              variant={"text"}
                                                                                              size={"small"}
                                                                                              color={"greySecondary"}
                                                                                              onClick={(e) => {
                                                                                                  this.onClickTreePath(
                                                                                                      item,
                                                                                                  );
                                                                                              }}
                                                                                              className={`depth ${
                                                                                                  item.isSelected
                                                                                                      ? "current"
                                                                                                      : ""
                                                                                              }`}
                                                                                              startIcon={
                                                                                                  <>
                                                                                                      {hierarchy[
                                                                                                          hierarchyActive
                                                                                                      ].history.navView
                                                                                                          .length >
                                                                                                      1 ? (
                                                                                                          <ImageBucketS3Off
                                                                                                              width={16}
                                                                                                              height={
                                                                                                                  16
                                                                                                              }
                                                                                                          />
                                                                                                      ) : (
                                                                                                          <ImageBucketS3On
                                                                                                              width={16}
                                                                                                              height={
                                                                                                                  16
                                                                                                              }
                                                                                                          />
                                                                                                      )}
                                                                                                      {item.type ===
                                                                                                          "bucket" && (
                                                                                                          <Grid
                                                                                                              container
                                                                                                              flexDirection={
                                                                                                                  "column"
                                                                                                              }
                                                                                                              justifyContent={
                                                                                                                  "center"
                                                                                                              }
                                                                                                              gap={0.25}
                                                                                                              sx={{
                                                                                                                  ".MzcCpIcon-root + * ":
                                                                                                                      {
                                                                                                                          margin: 0,
                                                                                                                      },
                                                                                                              }}
                                                                                                          >
                                                                                                              {item.uploadable ? (
                                                                                                                  <IconArrowUpload
                                                                                                                      size={
                                                                                                                          6
                                                                                                                      }
                                                                                                                      htmlColor={
                                                                                                                          "#2763ea"
                                                                                                                      }
                                                                                                                  />
                                                                                                              ) : (
                                                                                                                  <IconArrowUpload
                                                                                                                      size={
                                                                                                                          6
                                                                                                                      }
                                                                                                                      color={
                                                                                                                          "disabled"
                                                                                                                      }
                                                                                                                  />
                                                                                                              )}
                                                                                                              {item.downloadable ? (
                                                                                                                  <IconArrowDownload
                                                                                                                      size={
                                                                                                                          6
                                                                                                                      }
                                                                                                                      htmlColor={
                                                                                                                          "#2763ea"
                                                                                                                      }
                                                                                                                  />
                                                                                                              ) : (
                                                                                                                  <IconArrowDownload
                                                                                                                      size={
                                                                                                                          6
                                                                                                                      }
                                                                                                                      color={
                                                                                                                          "disabled"
                                                                                                                      }
                                                                                                                  />
                                                                                                              )}
                                                                                                          </Grid>
                                                                                                      )}
                                                                                                  </>
                                                                                              }
                                                                                          >
                                                                                              {item.name}
                                                                                          </Button>
                                                                                      </>
                                                                                  ) : (
                                                                                      <React.Fragment>
                                                                                          {hierarchy[hierarchyActive]
                                                                                              .history.navView.length >
                                                                                              2 &&
                                                                                              index === 1 && (
                                                                                                  <Menu
                                                                                                      width={160}
                                                                                                      placement={
                                                                                                          "right"
                                                                                                      }
                                                                                                      type={"icon"}
                                                                                                      label={
                                                                                                          <IconMoreHoriz
                                                                                                              size={16}
                                                                                                          />
                                                                                                      }
                                                                                                      color={"inherit"}
                                                                                                      size={"small"}
                                                                                                      list={hierarchy[
                                                                                                          hierarchyActive
                                                                                                      ].history.navView.slice(
                                                                                                          1,
                                                                                                          hierarchy[
                                                                                                              hierarchyActive
                                                                                                          ].history
                                                                                                              .navView
                                                                                                              .length -
                                                                                                              1,
                                                                                                      )}
                                                                                                  />
                                                                                              )}

                                                                                          {index ===
                                                                                              hierarchy[hierarchyActive]
                                                                                                  .history.navView
                                                                                                  .length -
                                                                                                  1 && (
                                                                                              <>
                                                                                                  <Button
                                                                                                      className={`depth ${
                                                                                                          hierarchy[
                                                                                                              hierarchyActive
                                                                                                          ]?.history
                                                                                                              ?.navView[
                                                                                                              hierarchy[
                                                                                                                  hierarchyActive
                                                                                                              ]?.history
                                                                                                                  ?.navView
                                                                                                                  .length -
                                                                                                                  1
                                                                                                          ].isSelected
                                                                                                              ? "current"
                                                                                                              : ""
                                                                                                      }`}
                                                                                                      variant={"text"}
                                                                                                      size={"small"}
                                                                                                      color={
                                                                                                          "secondary"
                                                                                                      }
                                                                                                      startIcon={
                                                                                                          <ImageFolderSmallOn
                                                                                                              width={16}
                                                                                                              height={
                                                                                                                  16
                                                                                                              }
                                                                                                          />
                                                                                                      }
                                                                                                  >
                                                                                                      {
                                                                                                          hierarchy[
                                                                                                              hierarchyActive
                                                                                                          ]?.history
                                                                                                              ?.navView[
                                                                                                              hierarchy[
                                                                                                                  hierarchyActive
                                                                                                              ]?.history
                                                                                                                  ?.navView
                                                                                                                  .length -
                                                                                                                  1
                                                                                                          ].name
                                                                                                      }
                                                                                                  </Button>
                                                                                              </>
                                                                                          )}
                                                                                      </React.Fragment>
                                                                                  )}
                                                                              </Grid>
                                                                          ),
                                                                      )
                                                                    : ""}
                                                            </Breadcrumbs>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item sx={{ display: `flex`, alignItems: `center`, gap: 1 }}>
                                                <VersionedComponent version={VERSION_CM_4750_UPLOAD_FOLDERS}>
                                                    <Tooltip title={t(`common::label::Files Upload`, "Files Upload")}>
                                                        <span>
                                                            <IconButton
                                                                circled
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    this.onClickToggleModal("files");
                                                                }}
                                                                disabled={
                                                                    this.state.bucketPath
                                                                        ? this.state.bucketPath.uploadDisabled
                                                                        : true
                                                                }
                                                            >
                                                                <IconFileUpload size={16} />
                                                            </IconButton>
                                                        </span>
                                                    </Tooltip>

                                                    <Tooltip title={t(`common::label::Folder Upload`, "Folder Upload")}>
                                                        <span>
                                                            <IconButton
                                                                circled
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    this.onClickToggleModal("folder");
                                                                }}
                                                                disabled={
                                                                    this.state.bucketPath
                                                                        ? this.state.bucketPath.uploadDisabled
                                                                        : true
                                                                }
                                                            >
                                                                <IconFolderUpload size={16} />
                                                            </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                </VersionedComponent>
                                                <VersionedComponent version={VERSION_SOURCE_VIEW_NEW_FOLDER}>
                                                    <Divider orientation={"vertical"} flexItem sx={{ my: 1 }} />
                                                    <Tooltip title={t(`common::label::New Folder`, "New Folder")}>
                                                        <span>
                                                            <IconButton
                                                                circled
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    // this.onClickToggleModal("newFolder");
                                                                    this.setShowModal("NEWFOLDER", true);
                                                                }}
                                                                disabled={
                                                                    this.state.bucketPath
                                                                        ? this.state.bucketPath.uploadDisabled
                                                                        : true
                                                                }
                                                            >
                                                                <IconFolderAdd size={16} />
                                                            </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                </VersionedComponent>
                                                {/*<button*/}
                                                {/*    type="button"*/}
                                                {/*    onClick={(e) =>*/}
                                                {/*        this.refreshFolderList(hierarchy[hierarchyActive].selected)*/}
                                                {/*    }*/}
                                                {/*    className={`btn btn-icon btn-transparent btn-refresh`}*/}
                                                {/*    disabled={*/}
                                                {/*        !hierarchy[hierarchyActive].history || hierarchy.pending*/}
                                                {/*            ? true*/}
                                                {/*            : false*/}
                                                {/*    }*/}
                                                {/*    data-tooltip={`${t("common::label::Refresh", `Refresh`)}`}*/}
                                                {/*>*/}
                                                {/*    <IconRefresh size={16}/>*/}
                                                {/*</button>*/}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item>
                                        <Collapse
                                            in={selectedItems && selectedItems.length > 0 && true}
                                            collapsedSize={1}
                                            sx={{
                                                backgroundColor: theme.palette.secondary.main,
                                                color: theme.palette.common.white,
                                                borderRadius: `3px`,
                                            }}
                                            ref={this.controlBarRef}
                                        >
                                            <VersionedComponent version={VERSION_SOURCE_VIEW_MUTATION}>
                                                <Grid
                                                    container
                                                    alignItems={"center"}
                                                    justifyContent={"space-between"}
                                                    p={1}
                                                >
                                                    <Grid item>
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    color={"greySecondary"}
                                                                    checked={isChecked}
                                                                    indeterminate={selectedItems?.length !== total}
                                                                />
                                                            }
                                                            label={
                                                                <>
                                                                    <Typography variant={"body3_700"}>
                                                                        {selectedItems.length}
                                                                    </Typography>
                                                                    <Typography
                                                                        variant={"body3_400"}
                                                                        sx={{ marginLeft: 0.5 }}
                                                                    >
                                                                        {t(`common::label::item selected`, `item selected`)}
                                                                    </Typography>
                                                                </>
                                                            }
                                                            onClick={() => {
                                                                this.onChangeAllSelectedItems(!isChecked);
                                                            }}
                                                            sx={{ ml: 0 }}
                                                        />
                                                    </Grid>
                                                    <Grid item>
                                                        <Grid container gap={1.5}>
                                                            <VersionedComponent
                                                                version={VERSION_CM_6169_SOURCE_MULTI_ASSET_CREATE}
                                                            >
                                                                <Tooltip
                                                                    title={`${t(
                                                                        "common::label::Create {{name}}",
                                                                        `Create {{name}}`,
                                                                        {
                                                                            name: t("common::label::Assets", `Assets`),
                                                                        },
                                                                    )}`}
                                                                >
                                                                    <span>
                                                                        <IconButton
                                                                            circled
                                                                            color={"inherit"}
                                                                            loading={this.state.isAssetCreating}
                                                                            disabled={
                                                                                this.state.isAssetCreating ||
                                                                                !fp.get("length", selectedItems) ||
                                                                                selectedItems.find((s) => s.isFolder)
                                                                            }
                                                                            onClick={(e) => {
                                                                                // if (selectedItems && selectedItems.length) {
                                                                                //     this.createAssets(selectedItems);
                                                                                // }
                                                                                CreateAssetsBulkActions.showModal(
                                                                                    this.getSelectedFiles(),
                                                                                );
                                                                                this.setState({
                                                                                    ...this.state,
                                                                                    selectedItems: [],
                                                                                    isChecked: false,
                                                                                });
                                                                            }}
                                                                        >
                                                                            <IconAssetsAdd size={16} />
                                                                        </IconButton>
                                                                    </span>
                                                                </Tooltip>
                                                                <Divider
                                                                    flexItem
                                                                    orientation={"vertical"}
                                                                    hidden={
                                                                        !fp.get("length", selectedItems) ||
                                                                        selectedItems.find((s) => s.isFolder)
                                                                    }
                                                                    sx={{ my: 0.5, opacity: 0.12 }}
                                                                />
                                                            </VersionedComponent>

                                                            <VersionedComponent
                                                                version={VERSION_CM_7794_STORAGE_DOWNLOAD_LINK}
                                                            >
                                                                <Tooltip
                                                                    title={`${t(
                                                                        "common::label::Share link",
                                                                        `Share link`,
                                                                    )}`}
                                                                >
                                                                    <span>
                                                                        <IconButton
                                                                            circled
                                                                            color={"inherit"}
                                                                            disabled={
                                                                                compareVersions(
                                                                                    stage.version,
                                                                                    VERSION_CM_7794_STORAGE_DOWNLOAD_LINK,
                                                                                ) < 0 ||
                                                                                !(selectedItems && selectedItems.length)
                                                                            }
                                                                            onClick={() => {
                                                                                if (
                                                                                    selectedItems &&
                                                                                    selectedItems.length
                                                                                ) {
                                                                                    this.setShowModal(
                                                                                        "DOWNLOADLINK",
                                                                                        true,
                                                                                    );
                                                                                }
                                                                            }}
                                                                        >
                                                                            <IconShareLink size={16} />
                                                                        </IconButton>
                                                                    </span>
                                                                </Tooltip>
                                                                <Divider
                                                                    flexItem
                                                                    orientation={"vertical"}
                                                                    sx={{ my: 0.5, opacity: 0.12 }}
                                                                />
                                                            </VersionedComponent>
                                                            <Tooltip
                                                                title={`${t("common::label::Copy to", `Copy to`)}`}
                                                            >
                                                                <span>
                                                                    <IconButton
                                                                        circled
                                                                        color={"inherit"}
                                                                        disabled={
                                                                            !(selectedItems && selectedItems.length) ||
                                                                            !isLockedByMeOrUnLocked
                                                                        }
                                                                        onClick={() => {
                                                                            if (selectedItems && selectedItems.length) {
                                                                                this.setShowModal("COPYTO", true);
                                                                            }
                                                                        }}
                                                                    >
                                                                        <IconFileCopyto size={16} />
                                                                    </IconButton>
                                                                </span>
                                                            </Tooltip>
                                                            <Tooltip title={`${t("common::label::Move", `Move`)}`}>
                                                                <span>
                                                                    <IconButton
                                                                        circled
                                                                        color={"inherit"}
                                                                        disabled={
                                                                            !(selectedItems && selectedItems.length) ||
                                                                            !isLockedByMeOrUnLocked
                                                                        }
                                                                        onClick={() => {
                                                                            if (selectedItems && selectedItems.length) {
                                                                                this.setShowModal("MOVETO", true);
                                                                            }
                                                                        }}
                                                                    >
                                                                        <IconMove size={16} />
                                                                    </IconButton>
                                                                </span>
                                                            </Tooltip>
                                                            <Tooltip title={`${t("common::label::Rename", `Rename`)}`}>
                                                                <span>
                                                                    <IconButton
                                                                        circled
                                                                        color={"inherit"}
                                                                        disabled={
                                                                            selectedItems.length === 0 ||
                                                                            selectedItems.length > 1 ||
                                                                            !isLockedByMeOrUnLocked
                                                                        }
                                                                        onClick={() => {
                                                                            if (selectedItems && selectedItems.length) {
                                                                                this.setShowModal("RENAME", true);
                                                                            }
                                                                        }}
                                                                    >
                                                                        <IconEditSmall size={16} />
                                                                    </IconButton>
                                                                </span>
                                                            </Tooltip>
                                                            <Divider
                                                                flexItem
                                                                orientation={"vertical"}
                                                                sx={{ my: 0.5, opacity: 0.12 }}
                                                            />
                                                            <VersionedComponent version={VERSION_CM_7307_DOWNLOAD}>
                                                                <Tooltip
                                                                    title={`${t(
                                                                        "common::label::Download",
                                                                        `Download`,
                                                                    )}`}
                                                                >
                                                                    <span>
                                                                        <IconButton
                                                                            circled
                                                                            color={"inherit"}
                                                                            disabled={
                                                                                mutationDownloadDisable ||
                                                                                !(selectedItems && selectedItems.length)
                                                                            }
                                                                            onClick={this.onClickDownload}
                                                                        >
                                                                            <IconDownload size={16} />
                                                                        </IconButton>
                                                                    </span>
                                                                </Tooltip>
                                                            </VersionedComponent>
                                                            <Divider
                                                                flexItem
                                                                orientation={"vertical"}
                                                                sx={{ my: 0.5, opacity: 0.12 }}
                                                            />
                                                            <Tooltip title={`${t("common::label::Delete", `Delete`)}`}>
                                                                <span>
                                                                    <IconButton
                                                                        circled
                                                                        color={"inherit"}
                                                                        disabled={
                                                                            !(selectedItems && selectedItems.length) ||
                                                                            !isLockedByMeOrUnLocked
                                                                        }
                                                                        onClick={(e) => {
                                                                            if (selectedItems && selectedItems.length) {
                                                                                this.setShowModal("DELETE", true);
                                                                            }
                                                                        }}
                                                                    >
                                                                        <IconDelete size={16} />
                                                                    </IconButton>
                                                                </span>
                                                            </Tooltip>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </VersionedComponent>
                                        </Collapse>
                                        <Grid container alignItems={`center`} justifyContent={`space-between`} py={1.5}>
                                            <Grid item>
                                                <Collapse in={selectedItems.length === 0} orientation="horizontal">
                                                    <Checkbox
                                                        color={"greySecondary"}
                                                        checked={selectedItems.length > 1}
                                                        indeterminate={
                                                            selectedItems.length > 0 && selectedItems.length !== total
                                                        }
                                                        disabled={mutationDisable && mutationDownloadDisable}
                                                        onChange={() => {
                                                            this.onChangeAllSelectedItems(!isChecked);
                                                        }}
                                                    />
                                                </Collapse>
                                            </Grid>
                                            <Grid item>
                                                <div className="control-pagination">
                                                    {compareVersions(
                                                        this.props.stage.version,
                                                        VERSION_CM_7104_STORAGE_TOKEN_BASE_PAGINATION,
                                                    ) >= 0 ? (
                                                        <CpmPagination
                                                            totalCount={
                                                                this.state.tokenPaginationInfo.data.length *
                                                                sources.search.defaultViewCountByToken
                                                            }
                                                            limit={sources.search.defaultViewCountByToken}
                                                            offset={this.state.tokenPaginationInfo.offset}
                                                            onChangeOffset={this.onChangeOffsetWithToken}
                                                            onRefresh={(e) => {
                                                                e.preventDefault();
                                                                this.refreshFolderList(
                                                                    hierarchy[hierarchyActive].selected,
                                                                );
                                                            }}
                                                            showOnlyRefresh={true}
                                                            showLimitChange={false}
                                                            isViewMore={true}
                                                            nextToken={
                                                                this.state.tokenPaginationInfo.data.length > 0
                                                                    ? this.state.tokenPaginationInfo.data[
                                                                          this.state.tokenPaginationInfo.data.length - 1
                                                                      ].nextToken
                                                                    : ""
                                                            }
                                                            onClickViewMore={this.onClickViewMore}
                                                        />
                                                    ) : (
                                                        <CpmPagination
                                                            totalCount={sources.objectTotalCount}
                                                            limit={sources.search.limit}
                                                            offset={sources.search.offset}
                                                            onChangeLimit={this.onChangeLimit}
                                                            onChangeOffset={this.onChangeOffset}
                                                            onRefresh={(e) => {
                                                                e.preventDefault();
                                                                this.refreshFolderList(
                                                                    hierarchy[hierarchyActive].selected,
                                                                );
                                                            }}
                                                            limitOptions={CONSTANTS("LIST_LIMITS")}
                                                            showTotalCount={true}
                                                        />
                                                    )}
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid
                                    item
                                    sx={{ flex: 1, overflow: `hidden`, display: `flex`, flexDirection: `column` }}
                                >
                                    <UploadDropzoneProvider
                                        accept={"*"}
                                        onDrop={this.onDropFile}
                                        disableClick={true}
                                        disabled={mutationDisable}
                                        stage={this.props.stage}
                                        emptyFolderEnable={true}
                                        className={"dropzone-wrapper"}
                                        parentFolder={this.props.sources.hierarchy?.folder?.selected}
                                        createNewFolders={this.onClickCreateNewFolders}
                                    >
                                        <TableContainer
                                            sx={{
                                                borderTop: `1px solid ${theme.palette.divider}`,
                                                overflow: "auto",
                                                height: `100%`,
                                            }}
                                        >
                                            <Table stickyHeader>
                                                <colgroup>
                                                    <col />
                                                    <col width={"130px"} />
                                                    <col width={"120px"} />
                                                    <col width={"160px"} />
                                                    <col width={"100px"} />
                                                </colgroup>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>{t(`common::label::Name`, `Name`)}</TableCell>
                                                        <TableCell style={{ minWidth: "130px" }}>
                                                            {t(`common::label::Size`, `Size`)}
                                                        </TableCell>
                                                        {/* 포르투갈어 "Classe de Armazenamento"가 180px에서
                                                            3줄까지 쪼개져 컬럼이 불안정해진다. 2줄로 안정화. */}
                                                        <TableCell style={{ minWidth: "200px" }}>
                                                            {t(`common::label::StorageClass`, `StorageClass`)}
                                                        </TableCell>
                                                        <TableCell style={{ minWidth: "170px" }}>
                                                            {t(`common::label::Last Modified`, `Last Modified`)}
                                                        </TableCell>
                                                        <TableCell style={{ minWidth: "100px" }}>
                                                            {t(`common::label::Action`, `Action`)}
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {pending && (
                                                        <TableRow>
                                                            <TableCell colSpan={5} className={"text-center"}>
                                                                <div className={"loading-block"}>
                                                                    <span className={"loading-content"}></span>
                                                                </div>
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                    {!pending && sources.objects && sources.objects.length === 0 && (
                                                        <TableRow>
                                                            <TableCell colSpan={5} className={"text-center"}>
                                                                {t(`common::label::Empty {{name}}`, `Empty {{name}}`, {
                                                                    name: t(`common::label::Objects`, `Objects`),
                                                                })}
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                    {!pending && sources.objects && sources.objects.length > 0 && (
                                                        <React.Fragment>
                                                            {folderList &&
                                                                folderList.map((v, i) => {
                                                                    return (
                                                                        <UploadDropzoneProvider
                                                                            key={i}
                                                                            accept={"*"}
                                                                            className={`${
                                                                                v ===
                                                                                (dropDownTarget &&
                                                                                    dropDownTarget.target)
                                                                                    ? "is-active-dropdown"
                                                                                    : ""
                                                                            }`}
                                                                            onDrop={this.onDropFile}
                                                                            disableClick={true}
                                                                            disabled={mutationDisable}
                                                                            stage={this.props.stage}
                                                                            extendPath={`${v.path ? `/${v.path}` : ""}`}
                                                                            emptyFolderEnable={true}
                                                                            variant={"table"}
                                                                            createNewFolders={
                                                                                this.onClickCreateNewFolders
                                                                            }
                                                                        >
                                                                            <>
                                                                                <TableCell>
                                                                                    <Grid
                                                                                        container
                                                                                        alignItems={"center"}
                                                                                        flexWrap={"nowrap"}
                                                                                    >
                                                                                        <VersionedComponent
                                                                                            version={
                                                                                                VERSION_SOURCE_VIEW_MUTATION
                                                                                            }
                                                                                        >
                                                                                            {mutationDisable &&
                                                                                            mutationDownloadDisable ? (
                                                                                                ""
                                                                                            ) : (
                                                                                                <Grid item>
                                                                                                    <Checkbox
                                                                                                        id={v.id}
                                                                                                        color={
                                                                                                            "greySecondary"
                                                                                                        }
                                                                                                        checked={selectedItems.includes(
                                                                                                            v,
                                                                                                        )}
                                                                                                        disabled={
                                                                                                            v.status &&
                                                                                                            v.status !==
                                                                                                                "SYNCED"
                                                                                                        }
                                                                                                        onChange={() =>
                                                                                                            this.onChangeSelectItem(
                                                                                                                v,
                                                                                                            )
                                                                                                        }
                                                                                                        onClick={(
                                                                                                            e,
                                                                                                        ) => {
                                                                                                            e.stopPropagation();
                                                                                                        }}
                                                                                                    />
                                                                                                </Grid>
                                                                                            )}
                                                                                        </VersionedComponent>
                                                                                        <Grid item>
                                                                                            <Grid
                                                                                                container
                                                                                                alignItems={"center"}
                                                                                                gap={1}
                                                                                                ml={1}
                                                                                            >
                                                                                                <ObjectIcon
                                                                                                    path={v.path}
                                                                                                    isFolder={
                                                                                                        v.isFolder
                                                                                                    }
                                                                                                />
                                                                                                <Grid item xs>
                                                                                                    {v.isFolder &&
                                                                                                    !(
                                                                                                        v.status &&
                                                                                                        v.status !==
                                                                                                            "SYNCED"
                                                                                                    ) ? (
                                                                                                        <Button
                                                                                                            variant={
                                                                                                                "solid"
                                                                                                            }
                                                                                                            sx={{
                                                                                                                minWidth: 0,
                                                                                                                textAlign: `left`,
                                                                                                            }}
                                                                                                            onClick={(
                                                                                                                e,
                                                                                                            ) => {
                                                                                                                const foundBucketChildren =
                                                                                                                    hierarchy.folder.data.filter(
                                                                                                                        (
                                                                                                                            item,
                                                                                                                        ) =>
                                                                                                                            item.name ===
                                                                                                                            this
                                                                                                                                .state
                                                                                                                                .bucketPath
                                                                                                                                .bucket,
                                                                                                                    );
                                                                                                                const targetFolder =
                                                                                                                    this.findTarget(
                                                                                                                        foundBucketChildren,
                                                                                                                        {
                                                                                                                            prefix: `${
                                                                                                                                this
                                                                                                                                    .state
                                                                                                                                    .bucketPath
                                                                                                                                    .folderPath
                                                                                                                                    ? `${this.state.bucketPath.folderPath}/`
                                                                                                                                    : ""
                                                                                                                            }${
                                                                                                                                v.path
                                                                                                                            }/`,
                                                                                                                        },
                                                                                                                    );
                                                                                                                if (
                                                                                                                    !targetFolder
                                                                                                                )
                                                                                                                    return;
                                                                                                                this.onClickTreePath(
                                                                                                                    targetFolder,
                                                                                                                );
                                                                                                            }}
                                                                                                        >
                                                                                                            {
                                                                                                                v.path.split(
                                                                                                                    "/",
                                                                                                                )[0]
                                                                                                            }
                                                                                                        </Button>
                                                                                                    ) : (
                                                                                                        <EllipsisTypography
                                                                                                            noWrap
                                                                                                        >
                                                                                                            {this.getObjectName(
                                                                                                                v.path,
                                                                                                            )}
                                                                                                        </EllipsisTypography>
                                                                                                    )}
                                                                                                </Grid>
                                                                                                {v.status &&
                                                                                                v.status !==
                                                                                                    "SYNCED" ? (
                                                                                                    <CircularProgress
                                                                                                        size={12}
                                                                                                        color={
                                                                                                            "greySecondary"
                                                                                                        }
                                                                                                    />
                                                                                                ) : (
                                                                                                    ""
                                                                                                )}
                                                                                            </Grid>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    style={{ minWidth: "130px" }}
                                                                                >
                                                                                    {v.isFolder
                                                                                        ? "-"
                                                                                        : v.size
                                                                                        ? convertToByte(v.size)
                                                                                        : ""}
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    style={{ minWidth: "200px" }}
                                                                                >
                                                                                    {v.isFolder
                                                                                        ? "-"
                                                                                        : v.storageClass || ""}
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    style={{ minWidth: "170px" }}
                                                                                >
                                                                                    {v.isFolder
                                                                                        ? "-"
                                                                                        : v.lastModified
                                                                                        ? convertUtcToLocal(
                                                                                              v.lastModified,
                                                                                          )
                                                                                        : "-"}
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    style={{ minWidth: "100px" }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                    }}
                                                                                >
                                                                                    <PopperMenu
                                                                                        ButtonComponent={
                                                                                            <Tooltip title={t(`common::label::More`, `More`)}>
                                                                                                <IconButton
                                                                                                    component={"span"}
                                                                                                    type={"button"}
                                                                                                    disabled={
                                                                                                        (compareVersions(
                                                                                                            this.props.stage
                                                                                                                .version,
                                                                                                            VERSION_SOURCE_VIEW_MUTATION,
                                                                                                        ) >= 0
                                                                                                            ? mutationDisable
                                                                                                            : true) ||
                                                                                                        (v.status &&
                                                                                                            v.status !==
                                                                                                                "SYNCED")
                                                                                                    }
                                                                                                >
                                                                                                    <IconMoreHoriz
                                                                                                        size={16}
                                                                                                    />
                                                                                                </IconButton>
                                                                                            </Tooltip>
                                                                                        }
                                                                                        insertButtonFunction={() => {
                                                                                            this.onClickToggleActionButton(
                                                                                                v,
                                                                                            );
                                                                                        }}
                                                                                        menuButtons={
                                                                                            compareVersions(
                                                                                                VERSION_SOURCE_VIEW_MUTATION,
                                                                                                this.props.stage
                                                                                                    .version,
                                                                                            ) <= 0 && !mutationDisable
                                                                                                ? [
                                                                                                      {
                                                                                                          skipTranslationLabel:
                                                                                                              t(
                                                                                                                  `common::label::Share link`,
                                                                                                                  `Share link`,
                                                                                                              ),
                                                                                                          onClick: (
                                                                                                              e,
                                                                                                          ) => {
                                                                                                              this.setShowModal(
                                                                                                                  "DOWNLOADLINK",
                                                                                                                  true,
                                                                                                              );
                                                                                                          },
                                                                                                          enable: true,
                                                                                                      },
                                                                                                      {
                                                                                                          skipTranslationLabel:
                                                                                                              t(
                                                                                                                  `common::label::Copy to`,
                                                                                                                  `Copy to`,
                                                                                                              ),
                                                                                                          onClick: (
                                                                                                              e,
                                                                                                          ) => {
                                                                                                              this.setShowModal(
                                                                                                                  "COPYTO",
                                                                                                                  true,
                                                                                                              );
                                                                                                          },
                                                                                                          enable: true,
                                                                                                          separate:
                                                                                                              compareVersions(
                                                                                                                  VERSION_CM_7794_STORAGE_DOWNLOAD_LINK,
                                                                                                                  this
                                                                                                                      .props
                                                                                                                      .stage
                                                                                                                      .version,
                                                                                                              ) <= 0,
                                                                                                          buttonDisabled:
                                                                                                              !isLockedByMeOrUnLocked,
                                                                                                      },
                                                                                                      {
                                                                                                          skipTranslationLabel:
                                                                                                              t(
                                                                                                                  `common::label::Move`,
                                                                                                                  `Move`,
                                                                                                              ),
                                                                                                          onClick: (
                                                                                                              e,
                                                                                                          ) => {
                                                                                                              this.setShowModal(
                                                                                                                  "MOVETO",
                                                                                                                  true,
                                                                                                              );
                                                                                                          },
                                                                                                          enable: true,
                                                                                                          buttonDisabled:
                                                                                                              !isLockedByMeOrUnLocked,
                                                                                                      },
                                                                                                      {
                                                                                                          skipTranslationLabel:
                                                                                                              t(
                                                                                                                  `common::label::Rename`,
                                                                                                                  `Rename`,
                                                                                                              ),
                                                                                                          onClick: (
                                                                                                              e,
                                                                                                          ) => {
                                                                                                              this.setShowModal(
                                                                                                                  "RENAME",
                                                                                                                  true,
                                                                                                              );
                                                                                                          },
                                                                                                          enable: true,
                                                                                                          buttonDisabled:
                                                                                                              !isLockedByMeOrUnLocked,
                                                                                                      },
                                                                                                      {
                                                                                                          Component:
                                                                                                              () => {
                                                                                                                  return (
                                                                                                                      <ElementActionItemDownloadV2
                                                                                                                          onClickDownload={
                                                                                                                              this
                                                                                                                                  .createDownloadJob
                                                                                                                          }
                                                                                                                          resourceType={
                                                                                                                              RESOURCE_TYPES.SOURCES
                                                                                                                          }
                                                                                                                          resources={[
                                                                                                                              {
                                                                                                                                  bucket: this
                                                                                                                                      .state
                                                                                                                                      .bucketPath
                                                                                                                                      .bucket,
                                                                                                                                  prefix: this
                                                                                                                                      .state
                                                                                                                                      .bucketPath
                                                                                                                                      .folderPath,
                                                                                                                                  fileName:
                                                                                                                                      v.path,
                                                                                                                              },
                                                                                                                          ]}
                                                                                                                          shouldZip={
                                                                                                                              true
                                                                                                                          }
                                                                                                                          expires={
                                                                                                                              600
                                                                                                                          }
                                                                                                                          projectId={
                                                                                                                              this
                                                                                                                                  .props
                                                                                                                                  .project
                                                                                                                                  .id
                                                                                                                          }
                                                                                                                          disabled={
                                                                                                                              !fp.get(
                                                                                                                                  "[0].downloadable",
                                                                                                                                  this.props.sources.resourceBuckets.filter(
                                                                                                                                      (
                                                                                                                                          bucket,
                                                                                                                                      ) =>
                                                                                                                                          bucket.name ===
                                                                                                                                          this
                                                                                                                                              .state
                                                                                                                                              .bucketPath
                                                                                                                                              .bucket,
                                                                                                                                  ),
                                                                                                                              ) ||
                                                                                                                              (v.status &&
                                                                                                                                  v.status !==
                                                                                                                                      "SYNCED")
                                                                                                                          }
                                                                                                                      />
                                                                                                                  );
                                                                                                              },
                                                                                                          enable:
                                                                                                              compareVersions(
                                                                                                                  VERSION_SOURCE_DOWNLOAD,
                                                                                                                  this
                                                                                                                      .props
                                                                                                                      .stage
                                                                                                                      .version,
                                                                                                              ) <= 0,
                                                                                                      },
                                                                                                      {
                                                                                                          skipTranslationLabel:
                                                                                                              t(
                                                                                                                  `common::label::Delete`,
                                                                                                                  `Delete`,
                                                                                                              ),
                                                                                                          onClick: (
                                                                                                              e,
                                                                                                          ) => {
                                                                                                              this.setShowModal(
                                                                                                                  "DELETE",
                                                                                                                  true,
                                                                                                              );
                                                                                                          },
                                                                                                          enable: true,
                                                                                                          separate: true,
                                                                                                          buttonDisabled:
                                                                                                              !isLockedByMeOrUnLocked,
                                                                                                      },
                                                                                                  ]
                                                                                                : []
                                                                                        }
                                                                                    />
                                                                                </TableCell>
                                                                            </>
                                                                        </UploadDropzoneProvider>
                                                                    );
                                                                })}
                                                            {fileList && (
                                                                <>
                                                                    {fileList.map((v, i) => {
                                                                        return (
                                                                            <TableRow
                                                                                key={i}
                                                                                className={`${
                                                                                    v.status && v.status !== "SYNCED"
                                                                                        ? "is-loading"
                                                                                        : ""
                                                                                }`}
                                                                                onClick={() => {
                                                                                    if (
                                                                                        compareVersions(
                                                                                            this.props.stage.version,
                                                                                            VERSION_CM_7441_STORAGE_PREVIEW,
                                                                                        ) >= 0
                                                                                    )
                                                                                        this.onClickRow(v);
                                                                                }}
                                                                            >
                                                                                <TableCell>
                                                                                    <Grid
                                                                                        container
                                                                                        alignItems={"center"}
                                                                                        flexWrap={"nowrap"}
                                                                                    >
                                                                                        <VersionedComponent
                                                                                            version={
                                                                                                VERSION_SOURCE_VIEW_MUTATION
                                                                                            }
                                                                                        >
                                                                                            {mutationDisable &&
                                                                                            mutationDownloadDisable ? (
                                                                                                ""
                                                                                            ) : (
                                                                                                <Grid item>
                                                                                                    <Checkbox
                                                                                                        color={
                                                                                                            "greySecondary"
                                                                                                        }
                                                                                                        checked={selectedItems.includes(
                                                                                                            v,
                                                                                                        )}
                                                                                                        onChange={() =>
                                                                                                            this.onChangeSelectItem(
                                                                                                                v,
                                                                                                            )
                                                                                                        }
                                                                                                        disabled={
                                                                                                            v.status &&
                                                                                                            v.status !==
                                                                                                                "SYNCED"
                                                                                                        }
                                                                                                        onClick={(
                                                                                                            e,
                                                                                                        ) => {
                                                                                                            e.stopPropagation();
                                                                                                        }}
                                                                                                    />
                                                                                                </Grid>
                                                                                            )}
                                                                                        </VersionedComponent>
                                                                                        <Grid item>
                                                                                            <Grid
                                                                                                container
                                                                                                alignItems={"center"}
                                                                                                gap={1}
                                                                                                ml={1}
                                                                                            >
                                                                                                <ObjectIcon
                                                                                                    path={v.path}
                                                                                                    isFolder={
                                                                                                        v.isFolder
                                                                                                    }
                                                                                                />
                                                                                                <Grid item xs>
                                                                                                    {v.isFolder ? (
                                                                                                        <Button
                                                                                                            variant={
                                                                                                                "solid"
                                                                                                            }
                                                                                                            sx={{
                                                                                                                minWidth: 0,
                                                                                                                textAlign: `left`,
                                                                                                            }}
                                                                                                            onClick={(
                                                                                                                e,
                                                                                                            ) => {
                                                                                                                const foundBucketChildren =
                                                                                                                    hierarchy.folder.data.filter(
                                                                                                                        (
                                                                                                                            item,
                                                                                                                        ) =>
                                                                                                                            item.name ===
                                                                                                                            this
                                                                                                                                .state
                                                                                                                                .bucketPath
                                                                                                                                .bucket,
                                                                                                                    );
                                                                                                                const targetFolder =
                                                                                                                    this.findTarget(
                                                                                                                        foundBucketChildren,
                                                                                                                        {
                                                                                                                            prefix: `${
                                                                                                                                this
                                                                                                                                    .state
                                                                                                                                    .bucketPath
                                                                                                                                    .folderPath
                                                                                                                                    ? `${this.state.bucketPath.folderPath}/`
                                                                                                                                    : ""
                                                                                                                            }${
                                                                                                                                v.path
                                                                                                                            }/`,
                                                                                                                        },
                                                                                                                    );
                                                                                                                if (
                                                                                                                    !targetFolder
                                                                                                                )
                                                                                                                    return;
                                                                                                                this.onClickTreePath(
                                                                                                                    targetFolder,
                                                                                                                );
                                                                                                            }}
                                                                                                        >
                                                                                                            {v.path}
                                                                                                        </Button>
                                                                                                    ) : (
                                                                                                        <Typography>
                                                                                                            {this.getObjectName(
                                                                                                                v.path,
                                                                                                            )}
                                                                                                        </Typography>
                                                                                                    )}
                                                                                                </Grid>
                                                                                                {v.status &&
                                                                                                v.status !==
                                                                                                    "SYNCED" ? (
                                                                                                    <CircularProgress
                                                                                                        size={12}
                                                                                                        color={
                                                                                                            "secondary"
                                                                                                        }
                                                                                                    />
                                                                                                ) : (
                                                                                                    ""
                                                                                                )}
                                                                                            </Grid>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    style={{ minWidth: "130px" }}
                                                                                >
                                                                                    {v.isFolder
                                                                                        ? "-"
                                                                                        : v.size
                                                                                        ? convertToByte(v.size)
                                                                                        : ""}
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    style={{ minWidth: "200px" }}
                                                                                >
                                                                                    {v.isFolder
                                                                                        ? "-"
                                                                                        : v.storageClass || ""}
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    style={{ minWidth: "170px" }}
                                                                                >
                                                                                    {v.isFolder
                                                                                        ? "-"
                                                                                        : v.lastModified
                                                                                        ? convertUtcToLocal(
                                                                                              v.lastModified,
                                                                                          )
                                                                                        : "-"}
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    style={{ minWidth: "100px" }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                    }}
                                                                                >
                                                                                    <PopperMenu
                                                                                        ButtonComponent={
                                                                                            <Tooltip title={t(`common::label::More`, `More`)}>
                                                                                                <IconButton
                                                                                                    component={"span"}
                                                                                                    circled
                                                                                                    disabled={
                                                                                                        v.status &&
                                                                                                        v.status !==
                                                                                                            "SYNCED"
                                                                                                    }
                                                                                                >
                                                                                                    <IconMoreHoriz
                                                                                                        size={16}
                                                                                                    />
                                                                                                </IconButton>
                                                                                            </Tooltip>
                                                                                        }
                                                                                        insertButtonFunction={() => {
                                                                                            this.onClickToggleActionButton(
                                                                                                v,
                                                                                            );
                                                                                        }}
                                                                                        menuButtons={this.createObjectFeatureMenus(
                                                                                            t,
                                                                                            v,
                                                                                            mutationDisable,
                                                                                            hideContents,
                                                                                            isLockedByMeOrUnLocked,
                                                                                        )}
                                                                                    />
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        );
                                                                    })}
                                                                </>
                                                            )}
                                                        </React.Fragment>
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </UploadDropzoneProvider>
                                </Grid>
                            </Grid>
                        </Grid>

                        {/*{this.state.isDragActive && (*/}
                        {/*    <div className={`dropify-wrapper card-body`}>*/}
                        {/*        <div className={"drag-wrap"}>*/}
                        {/*            <div className={"drag-active"}>*/}
                        {/*                <ImageUpload width={78} height={62}/>*/}
                        {/*                <p>{t(`common::msg::${"Drag your files to upload"}`)}</p>*/}
                        {/*            </div>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*)}*/}
                    </>
                )}
            </React.Fragment>
        );
    };
}

let mapStateToProps = (state) => {
    return {
        user: state.user,
        global: state.global,
        stage: state.stage,
        project: state.project,
        sources: state.sources,
        propertyPanel: state.propertyPanel,
        settings: state.settings,
        upload: state.upload,
        uploadQueue: state.uploadQueue,
        createAssetsBulk: state.createAssetsBulk,
    };
};

let mapStateToDispatch = (dispatch) => {
    return {
        dispatch,
        SourcesActions: bindActionCreators(sourcesActions, dispatch),
        PropertyPanelActions: bindActionCreators(propertyPanelActions, dispatch),
        SettingsActions: bindActionCreators(settingsActions, dispatch),
        UploadActions: bindActionCreators(uploadActions, dispatch),
        UploadQueueActions: bindActionCreators(uploadQueueActions, dispatch),
        MyJobsActions: bindActionCreators(myJobsActions, dispatch),
        RightSideBarActions: bindActionCreators(rightSideBarActions, dispatch),
        SharesActions: bindActionCreators(sharesActions, dispatch),
        NotificationActions: bindActionCreators(notificationActions, dispatch),
        DownloadJobsActions: bindActionCreators(downloadJobsActions, dispatch),
        CreateAssetsBulkActions: bindActionCreators(createAssetsBulkActions, dispatch),
    };
};

const ConnectedList = connect(mapStateToProps, mapStateToDispatch)(withCheckPermissionWrapper(checkPermissionConfigs)(List));
export default withTranslation()(ConnectedList);
